import React, { Component } from "react";
import * as Constants from "../../../common/Global/constants";
import * as TemplateConstants from "../../../common/Global/templateConstants";
import Sidebar from "../../../common/SidebarCollapse";
import Topbar from "../../../common/Topbar";
import TableDropDown from "../../../common/DropdownMenus/TableDropdown";
import AlertDialog from "../../../common/AlertDialog";
import SelectRiskDialog from "./selectRisk";
import { getFollowUpTasks } from "../../../common/Global/reviewFunctions";
import { getLocalStorageVariables, getThemeSettingsVariables, isEmptyVariable, isEmptyArray,
     removeHtmlTags, isJsonString, hasFeatureAccess,
     handleTokenExpiry,
     getTrimmedText} from "../../../common/Global/commonFunctions";
import RegularDropdown from '../../../common/DropdownMenus/RegularDropdownTable';
import { getCheckListScoresFlag, getOnlyMyTasks, getMatrixandMyDetails, getRankingArray } from '../Tasks/execTaskUtilFunctions';
import FollowUpUpdateAssignmentTaskReviewStatus from "./followUpUpdateReviewStatusDialog";
import RegularDD from '../../../common/DropdownMenus/RegularDropdown';
import { BrowserRouter as Router } from "react-router-dom";
import FollowupHeading from "../Common/followupHeadingDetails";
import moment from "moment";
import DatePickerComponent from "../../Tasks/Common/dateSelectComponent";
import FilterDropDown from "../../../common/DropdownMenus/FilterDropdown";
import ReviewHistoryDialog from "../../../common/reviewhistorydialog";
import AddFollowUpTemplateValueDialog from "../Common/addFollowUpTemplateValueDialog";
import FollowUpDetailsDialog from "./followUpDetailsDialog";
import TaskDetailsLayout from '../../Tasks/taskDetailsWithTemplates';
import UploadAnnexureDialog from "./UploadAnnexure";
import ViewResponseCommentDialog from "../../Reports/Ongoing/viewResponseCommentsdialog";
import PreviousAssignmentDialog from "../Common/previousAssignmentDialog";
import ReviewCommentsDialog from "../../Execute/Tasks/reviewCommentsdialog";
import FrameworkClauseInfoDialog from "../../Tasks/Common/frameworkClauseInfoDialog";

const defaultWeightPlaceholder = "Rank";
const defaultYNPlaceholder = "Rank";
let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();
const filterOpenCloseDropDownArr = [
    {
        label: "Checked & Open",
        isSelected: true,
    },
    {
        label: "Close",
        isSelected: false,
    },
];

class FollowUpTask extends Component {
    constructor(props) {
        super(props);
        const item = props.location.state;
        this.state = {
            assignmentId: props.match.params.id,
            departmentId: item.departmentId,
            observationTemplateId: item.observationTemplateId,
            observationTaskFilterDropDownArr: item.observationTaskFilterDropDownArr,
            observationTaskFilterPlaceholder: item.observationTaskFilterPlaceholder,

            componentDidMountFlag: false,
            showLoader: false,
            currentPageNo: 1,
            resultSize: Constants.RESULT_SIZE,
            datalist: [],
            allDataList: [],
            
            assignmentStatus: "",
            assignmentArea: "",
            assignmentDetails: "",
            
            selectedTaskTemplateFields: [],
            taskTemplateValuesMap: {},
            execTaskTemplateFields: [],
            executionTemplateValuesMap: {},
            executionTemplateFixedFields: {},
            followUpTemplateFixedFields: {},
            
            showAlertDialog: false,
            operationType: "",
            deleteReactivateId: "",
            deleteReactivateMasterType: "",
            reviewLevel: "",
            alertDialogMessage: "",
            alertDialogHeading: "",
            proceedBtnLabel: "",
            showBtnLoader: false,
            showAlertDialogInfo: false,
            alertDialogMessageInfo: "",
            showUpdateReviewDialog: false,
            showReviewHistoryDialog:false,
            remarks: "",
            currentReviewLevel:"",
            endReviewLevel:"",
            
            assignmentMatrix: [],
            selectedResourceUserName: "",
            selectedResourceId: "",
            myPosition: "",
            
            overallChecklistScoreObj: {},
            checklistMaxRank: 0,

            showSelectUploadAnnexureDialog: false,
            isBackup: false,
            assignmentTaskUserId: "",
            isEditable:false,

            filterDataList: [],
            filterDropDownArr: [],
            filterPlaceholder: "All",

            singleSelectDropDownArr: [],

            followUpTaskTemplateList: [],
            showFollowUpTemplateValueDialog:false,
            filterOpenCloseDropDownArr: filterOpenCloseDropDownArr,
            filterOpenClosePlaceholder: "Open",
            assignmentTaskId:"",
            isFollowUpTemplateValueEditDialog:false,

            //Risk
            showSelectRiskDialog: false,
            selectedRiskObj: "",
            deptDefaultRisk: {},

            allAnnexureList:[],

            selectFollowUpTemplate:"",
            showFollowUpDetailsDialog: false,
            followUpDetailsItem:{},

            showTaskDetailsLayout: false,
            selectedTaskIdForDetails: "",
            user: {},
            isShowHeader:true,
            followUpTaskItem:false,
            isIndustryFlag:false,
            isSampleChecked:false,
            showViewResponseDialog: false,
            selectedAssignmentTaskId:"",
            isIndustryFlag:false,
            isClientResponseAfterCompletion:false,
            hasTaskTemplateScore:false,
            hasTaskTemplateWeightedScore:false,
            likelihoodRiskMatrix: [],
            selectedLikelihoodRiskId: "",
            showPreviousAssignmentData:false,
            assignmentExecuteFields:[],
            isTemplateSettingRisk:false,
            previousAssignmentDataList:[],
            showFrameworkClauseInfoDialog:false,
            framworkClaueItem:{},
            frameworkName:""
        };
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount() {
        this.getInitData();
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props)){
            this.setState({
                componentDidMountFlag:false,
                showLoader:false,
                datalist:[],
                allDataList: [],
            },()=>{
                this.getInitData();
            })
        }
    }
    
    // Risk
    handleSelectRiskDialogShow = (taskItem) => {
        
        //User should select the department before selecting default risk
        let focusObj = this.state.filterDataList.length>0?this.state.filterDataList:this.state.datalist;
        const selectedRisk =  !isEmptyArray(Object.keys(this.state.deptDefaultRisk)) && this.state.deptDefaultRisk[this.state.assignmentDetails.departmentId].filter(item => {
            if(item.riskLevelId == taskItem.followUpRiskLevelId){
                return item;
            }
        })
        
        this.setState({
            selectedRiskObj:isEmptyArray(selectedRisk)?"":selectedRisk[0],
            showSelectRiskDialog: true,
            assignmentTaskId:taskItem.assignmentTaskId,
            selectedAssignmentTaskRiskLevelId: taskItem.assignmentTaskRiskLevelId,
            selectedLikelihoodRiskId: taskItem.likelihoodRiskId,
            ...focusObj,
        });
    };

    handleSelectRiskDialogClose = (reloadFlag) => {
        this.setState({
            showSelectRiskDialog: false,
            selectedRiskObj:"",
            assignmentTaskId: "",
            selectedAssignmentTaskRiskLevelId: "",
            selectedLikelihoodRiskId: ""
        },() => {
            if (reloadFlag === true) {
                this.getFollowUpTaskTab();
            }
        });
    };

    handleSelectRiskDialogSaveClose = (selectedRiskObj) => {
        this.setState({
            showSelectRiskDialog: false,
            selectedRiskObj: selectedRiskObj,
        });
        this.getFollowUpTaskTab();
    };

    handleAlertDialogClose = () => {
        this.setState({
            showAlertDialog: false,
            alertDialogMessage: "",
        });
    };

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo: false,
            alertDialogMessageInfo: "",
        });
    };

    handleReviewHistoryDialogClose = () => {
        this.setState({
            showReviewHistoryDialog:false,
            deleteReactivateId:"",
        });
    }

    handleFollowUpDetailsDialogShow = (followUpItem,assignmentTaskId,item) => {
        this.setState({
            showFollowUpDetailsDialog:true,
            followUpDetailsItem:followUpItem,
            assignmentTaskId:assignmentTaskId,
            followUpTaskItem:this.taskEditable(item)
        });
    }
    
    handleFollowUpDetailsDialogClose = () => {
        this.setState({
            showFollowUpDetailsDialog:false
        });
    }

    handleShowTaskDetailsLayout = (taskId) => {
        this.setState({
            isShowHeader:false,
            showTaskDetailsLayout: true,
            selectedTaskIdForDetails: taskId,
        });
    };

    frameworkClauseInfo = (item,frameworkName,e) => {
        e.stopPropagation();
        this.setState({
            showFrameworkClauseInfoDialog:true,
            framworkClaueItem:item,
            frameworkName:frameworkName
        })
    }

    handleFrameworkClauseDialogClose = () => {
        this.setState({
            showFrameworkClauseInfoDialog:false,
            framworkClaueItem:{},
            frameworkName:""
        })
    }

    handleHideTaskDetailsLayout = () => {
        this.setState({
            isShowHeader:true,
            showTaskDetailsLayout: false,
            selectedTaskIdForDetails: "",
        });
    };

    onTableDropDownItemClick = (item, dropdownItem) => {
        if (item.label === "Follow Up Details") {
            this.getPreviousFollowUpTaskTemplateValues(dropdownItem.assignmentTaskId, dropdownItem.observationId, dropdownItem);
        } else if (item.label === "Submit For Review") {
            this.setState({
                operationType: item.label,
                alertDialogHeading: "Submit For Review",
                proceedBtnLabel: "Submit",
                deleteReactivateId: dropdownItem.assignmentTaskId,
                showAlertDialog: true,
                alertDialogMessage: "Are you sure you want to submit for review?",
            });
        } else if (item.label === "Start Review") {
            this.setState({
                operationType:item.label,
                alertDialogHeading:"Start Review",
                proceedBtnLabel:"Start",
                reviewLevel:dropdownItem.reviewLevel,
                deleteReactivateId:dropdownItem.assignmentId,
                showAlertDialog:true,
                alertDialogMessage:"Are you sure you want to start review of "+dropdownItem.companyName+" assignment?"
            })
        } else if (item.label === "Update Review Status") {
            this.setState({
                reviewLevel: dropdownItem.reviewLevel,
                deleteReactivateId: dropdownItem.assignmentTaskId,
                showUpdateReviewDialog: true,
                currentReviewLevel:dropdownItem.currentReviewLevel,
                endReviewLevel:dropdownItem.endReviewLevel
            });
        } else if (item.label === "Review History") {
            this.setState({
                deleteReactivateId:isEmptyVariable(dropdownItem.observationId)?dropdownItem.assignmentTaskId:dropdownItem.observationId,
                showReviewHistoryDialog:true,
            })
        } else if(item.label === "Auditee Response"){
            this.setState({
                selectedObservationId:dropdownItem.observationId,
                showViewResponseDialog:true,
                selectedAssignmentTaskId:dropdownItem.assignmentTaskId,
            })
        }
    };

    handleViewResponseDialogClose = (reloadFlag) =>{
        this.setState({
            showViewResponseDialog:false
        },() => {
            if (reloadFlag === true) {
                this.getFollowUpTaskTab();
            }
        })
    }

    maxrDropdownClick = (selectedItem, udf) => {
        this.setState({
            showLoader: true,
        });

        let iapArr = udf.split(":-:");
        let index = iapArr[0];
        let parentId = iapArr[1];
        let list = this.state.datalist;
        list[parentId].taskList[index].rank = selectedItem.id;

        this.setState({
            datalist: list,
            showLoader: false,
        },
        () => {
            this.handleSaveAssignmentTaskProperties(
                list[parentId].taskList[index].assignmentTaskId,
                selectedItem.id,
                "rank"
            );
        });
    };

    resourceDropdownItemClick = (selectedItem) => {
        let arr = this.getUserTasksFromUserId(selectedItem.id);
        let tempFilterArray = [
            {
                label: "All",
                isSelected: true,
            },
        ];

        Object.values(arr).map((item) => {
            let uid = 0;
            Object.values(item.taskList).map((task) => {
                uid = task.userId;
            });
            if (uid == selectedItem.id) {
                tempFilterArray.push({
                    label: this.state.assignmentArea === "Process" ? item.processName : this.state.assignmentArea === "Function" ? item.functionName : item.heading,
                    isSelected: false,
                });
            }
        });

        this.singleSelectAll();
        
        this.setState({
            selectedResourceId: selectedItem.id,
            selectedResourceUserName: selectedItem.label,
            datalist: arr,
            filterDropDownArr: tempFilterArray,
            filterPlaceholder: "All",
            filterDataList: [],
        });
    };

    getUserTasksFromUserId = (userId) => {
        let allData = JSON.parse(JSON.stringify(this.state.allDatalist));
        let arr = allData.map((process) => {
            let taskList = [];
            let maxScore = 0;
            let totalScore = 0;
            process.taskList.forEach((task) => {
                if (task.userId + "" === userId + "") {
                    taskList.push(task);

                    //Now if it is checklist, then based on the type of checklist we need to assign scores
                    if (this.state.assignmentArea === "CheckList") {
                        let weight = isEmptyVariable(task.weight) ? 1 : task.weight;
                        let rank =
                            isEmptyVariable(task.rank) || task.rank === -1 ? 0 : task.rank;

                        //if rank is NA then that should be considered for max score also
                        let maxRankNew = task.rank === -1 ? 0 : this.state.checklistMaxRank;
                        maxScore += weight * maxRankNew;
                        totalScore += weight * rank;
                    }
                }
            });
            process.taskList = taskList;
            process.maxScore = maxScore;
            process.totalScore = totalScore;
            return process;
        });
        return arr;
    };

    getTaskDisplayValues = (taskId, fieldItem) => {
        if (isEmptyVariable(this.state.taskTemplateValuesMap[taskId])) {
            return "-";
        }

        let fieldId = fieldItem.fieldId;
        if (isEmptyVariable(this.state.taskTemplateValuesMap[taskId][fieldId])) {
            return "-";
        }

        let displayValue =
            this.state.taskTemplateValuesMap[taskId][fieldId]["value"];
        if (isEmptyVariable(displayValue)) {
            return "-";
        }

        switch (fieldItem.fieldType) {
            case TemplateConstants.FIELD_TYPE_TEXT:
                return getTrimmedText(removeHtmlTags(displayValue),20);
            case TemplateConstants.FIELD_TYPE_DATE:
                return isEmptyVariable(displayValue)
                    ? ""
                    : moment(displayValue).format("DD/MM/YYYY");
            case TemplateConstants.FIELD_TYPE_SINGLE_SELECT:
            case TemplateConstants.FIELD_TYPE_ISO:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_DROPDOWN:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_MULTI_SELECT:
                if (!isJsonString(displayValue)) {
                    return "-";
                }
                return JSON.parse(displayValue).join(", ");
            case TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI:
                if (!isJsonString(displayValue)) {
                    return "-";
                }
                return JSON.parse(displayValue).join(", ");
            case TemplateConstants.FIELD_TYPE_NUMERIC:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_VALUE_ADDITION:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_YES_NO:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_SCORE:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_FRAMEWORK:
                // 1. Group the framework clauses by frameworkName
                try {
                    const frameworkArray = displayValue;
                    const groupedData = frameworkArray.reduce((acc, item) => {
                        // Use frameworkId or frameworkName for grouping
                        const key = item.frameworkName;
                        if (!acc[key]) {
                            acc[key] = {
                                name: item.frameworkName,
                                clauses: []
                            };
                        }
                        // Extract and clean the clause name
                        let clauseName = item.frameworkClauseName.trim();
                        const shortNameWithSpace = ' ' + item.frameworkShortName;

                        // Clean up the clause name (e.g., remove " PAF" from "Clause 4.4.1 PAF")
                        if (clauseName.endsWith(shortNameWithSpace)) {
                            clauseName = clauseName.substring(0, clauseName.lastIndexOf(shortNameWithSpace)).trim();
                        }
                        acc[key].clauses.push({
                            name: clauseName,
                            order: item.frameworkClauseOrder,
                            frameworkClauseItem:item // Keep the full item for info icon binding
                        });
                        return acc;
                    }, {});

                    // Get the list of framework groups (for checking single vs. multiple)
                    const frameworkGroups = Object.values(groupedData);

                    // Check if only one framework is used (based on the grouped data count)
                    const isSingleFramework = frameworkGroups.length === 1;

                    // 2. Format the grouped data into the required string array
                    const formattedStrings = frameworkGroups.map((group, index) => {
                        // Sort clauses based on their original order
                        const sortedClauses = group.clauses.sort((a, b) => a.order - b.order);

                        // Generate an array of JSX elements, each containing the clause name, its info icon, and a separator
                        const clauseElements = sortedClauses.flatMap((clause, clauseIndex) => {
                            const elements = [
                                <div 
                                    key={`clause-item-${index}-${clauseIndex}`} 
                                    className="d-flex align-items-center" // Use flex to keep name, icon, separator inline
                                >
                                    {/* 1. Clause Name */}
                                    <span 
                                        className="task-dangerouslysethtml framework-inline" 
                                        dangerouslySetInnerHTML={{ __html: ` ${clause.name}` }} 
                                    />
                                    {/* 2. Info Icon for the Clause */}
                                    <div
                                        key={`info-${index}-${clauseIndex}`}
                                        className="tool hover-item framework-info-icon"
                                        data-title="Clause Details"
                                    >
                                        <span
                                            onClick={this.frameworkClauseInfo.bind(this, clause.frameworkClauseItem, group.name)}
                                            className="material-icons-outlined framework-icon"
                                            style={{ cursor: 'pointer', verticalAlign: 'middle' }}
                                        >
                                            info
                                        </span>
                                    </div>
                                </div>
                            ];

                            // 3. Add a separator (comma and space) if it's not the last clause
                            if (clauseIndex < sortedClauses.length - 1) {
                                elements.push(
                                    <span key={`sep-${index}-${clauseIndex}`} className="framework-clause-separator">
                                        ,&nbsp;
                                    </span>
                                );
                            }

                            return elements;
                        });

                        return (
                            <div key={index} className="framework-line-container">
                                <div className="framework-group-line d-flex">
                                    <div className="framework-text-content-combined d-flex flex-wrap align-items-center">
                                        {/* Conditional Display of Framework Name */}
                                        {!isSingleFramework && (
                                            <span className="framework-name-text">
                                                {group.name}&nbsp;
                                            </span>
                                        )}
                                        {/* Render the array of clause names and icons */}
                                        <div className="framework-clauses-container d-flex flex-wrap">
                                            {clauseElements}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    });
                    return formattedStrings;
                } catch (error) {
                    return displayValue;
                }
        }
        return "-";
    };

    handleUpdateReviewDialogClose = (reloadFlag) => {
        if (reloadFlag === true) {
            this.setState({
                showUpdateReviewDialog: false,
                deleteReactivateMasterType: "",
                deleteReactivateId: "",
                reviewLevel: "",
            },() => {
                this.getFollowUpTaskTab();
            });
        }else{
            this.setState({
                showUpdateReviewDialog: false,
            })
        }
    };

    taskFilterDropDownOnClicks = (selectedItem) => {
        let tempObservationFilterDataArray = this.state.observationTaskFilterDropDownArr;
        Object.values(tempObservationFilterDataArray).map((item) => {
            if (selectedItem.label === item.label) {
                item.isSelected = true;
            } else {
                item.isSelected = false;
            }
        });
       
        if(selectedItem.label === "Observation"){
            this.props.history.replace(Constants.URL_FOLLOWUPOBSERVATION + "/" + this.state.assignmentId,{
                departmentId:this.state.departmentId,
                observationTemplateId:this.state.observationTemplateId,
                observationTaskFilterDropDownArr:tempObservationFilterDataArray,
                observationTaskFilterPlaceholder:selectedItem.label
            }); 
        }
    }

    filterOpenCloseDropDownOnClick = (taskItem,selectedItem) => {
        let tempFilterDataArray = this.state.filterOpenCloseDropDownArr;
        let placeholder = "";

        if(!selectedItem.label.includes(taskItem.closeOpenStatus)){
            
            tempFilterDataArray.map((item) => {
                if (item.label === selectedItem.label) {
                    item.isSelected = true;
                } else {
                    item.isSelected = false;
                }
            });
            placeholder = (selectedItem.label==="Checked & Open")?"Open":selectedItem.label;
            if(selectedItem.label === "Close"){
                this.setState({
                    showAlertDialog:true,
                    alertDialogHeading:"",
                    alertDialogMessage:"You are about to close a follow-up. It will not be editable anymore. Are you sure you want to close the follow-up?",
                    proceedBtnLabel:"Yes",
                    operationType:"CloseFollowUp",
                    deleteReactivateId:taskItem.assignmentTaskId
                })
            }else{
                this.getFollowupTaskTemplatevalues(taskItem.assignmentTaskId);
                this.setState({
                    showFollowUpTemplateValueDialog:true,
                    isFollowUpTemplateValueEditDialog:false,
                    filterOpenCloseDropDownArr: tempFilterDataArray,
                    selectFollowUpTemplate: selectedItem.label
                })
            }
        }
    }

    handleFollowUpTemplateValueDialogClose = (reloadFlag) => {
        this.setState({
            showFollowUpTemplateValueDialog:false
        },() => {
            if(reloadFlag == true){
                this.getFollowUpTaskTab()
            }
        })
    }

    singleSelectFilterDropDownOnClick = (fieldId,selectedItem) => {
        let placeholder = "";
        let tempSingleSelectFilterDataArray = this.state.singleSelectDropDownArr;
        
        //Set placeholder based on selection 
        Object.values(tempSingleSelectFilterDataArray).forEach(item => {
            if(item.fieldId === fieldId){
                Object.values(item.dropdownValues).map(dropdownItem => {
                    if (selectedItem.label === dropdownItem.label) {
                        dropdownItem.isSelected = true;
                        if(dropdownItem.label!=="All"){
                            placeholder = dropdownItem.label;
                        }
                        item.placeholderValue = placeholder;
                    }else{
                        dropdownItem.isSelected = false;
                    }
                })
            }
        })

        // Single Select filter datalist based on dropdown item selection
        let datalist = [];
        let tempFilterSingleSelectPlaceHolderDataList = tempSingleSelectFilterDataArray.filter(item => !isEmptyVariable(item.placeholderValue));
        let selectedPlaceHolder = tempFilterSingleSelectPlaceHolderDataList.map(item => item.placeholderValue);

        if(tempFilterSingleSelectPlaceHolderDataList.length === 0){
            datalist = this.getUserTasksFromUserId(this.state.selectedResourceId);
        }else{
            tempSingleSelectFilterDataArray.map(singleSelectItem => {
                datalist = this.getUserTasksFromUserId(this.state.selectedResourceId).map(functionObj=>({
                    ...functionObj,
                    taskList: functionObj.taskList.filter(taskItem => {
                        return selectedPlaceHolder.includes(this.state.executionTemplateValuesMap[taskItem.assignmentTaskId]?.[singleSelectItem.fieldId]?.["valueNR"]==="Y"?
                        "NA":this.state.executionTemplateValuesMap[taskItem.assignmentTaskId]?.[singleSelectItem.fieldId]?.["value"])
                    })
                })).filter(item => item.taskList.length > 0);
            })
        }

        let tempFilterDataArray = this.state.filterDropDownArr;
        tempFilterDataArray.map((item) => {
            if (item.label === "All") {
                item.isSelected = true;
            } else {
                item.isSelected = false;
            }
        });

        this.setState({
            datalist: datalist,
            singleSelectDropDownArr: tempSingleSelectFilterDataArray,
            filterDataList:[],
            filterDropDownArr: tempFilterDataArray,
            filterPlaceholder:this.state.assignmentArea
        });
    }

    singleSelectAll = () => {
        //Single Select filter selection default All
        let tempSingleSelectFilterDataArray = this.state.singleSelectDropDownArr;
        Object.values(tempSingleSelectFilterDataArray).forEach(item => {
            Object.values(item.dropdownValues).map(dropdownItem => {
                if (dropdownItem.label === "All") {
                    dropdownItem.isSelected = true;
                    item.placeholderValue = "";
                }else{
                    dropdownItem.isSelected = false;
                }
            })
        })
        this.setState({
            singleSelectDropDownArr: tempSingleSelectFilterDataArray
        })
    }

    closePreviousAssignDialogBox = () =>{
        this.setState({
            showPreviousAssignmentData:false
        })
    }

    previousAssignmentData = (taskItem, leafNodeId) => {
        fetch(Constants.PreviousAssignmentData,{
            method: "POST",
            mode: "cors",
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                assignmentId: this.state.assignmentId,
                taskId:taskItem.taskId,
                assignmentTaskId:taskItem.assignmentTaskId,
                leafNodeId:leafNodeId,
                forDraft:true
            }),
        }).then((response) => {
            return response.json();
        }).then((data)=>{
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                this.setState({
                    showPreviousAssignmentData:true,
                    assignmentExecuteFields:data.executeField,
                    previousAssignmentDataList:data.data
                })
                
            }

        })
    }

    filterDropDownOnClick = (selectedItem) => {
        this.singleSelectAll();
        let tempFilterDataList = [];
        let arr = this.getUserTasksFromUserId(this.state.selectedResourceId);
        let tempFilterDataArray = this.state.filterDropDownArr;

        if (selectedItem.label === 'All') {
            this.setState({
                filterDataList: [],
                datalist:this.state.allDatalist
            })
        } else if (selectedItem.label !== "All") {
            Object.values(arr).map((item) => {
                let tempDataTaskList = []
                Object.values(item.taskList).map((task) => {
                    if ((selectedItem.label === (this.state.assignmentArea === "Process" ? item.processName : this.state.assignmentArea === "Function" ? item.functionName : item.heading))) {
                        tempDataTaskList.push(task)
                    }
                })
                item.taskList = tempDataTaskList
                tempFilterDataList.push(item)
            })
        }

        tempFilterDataArray.map((item) => {
            if (item.label === selectedItem.label) {
                item.isSelected = true;
            } else {
                item.isSelected = false;
            }
        });
        
        this.setState({
            filterPlaceholder: selectedItem.label,
            filterDataList: tempFilterDataList,
            filterDropDownArr: tempFilterDataArray,
        })
    }; 

    taskEditable = (taskItem) => {
        let endReviewUserId = "";
        for(var i=0;i<7;i++){
            if(taskItem.endReviewLevel===i){
                endReviewUserId=taskItem[`L${i}UserId`]
            }
        }
        if(taskItem.closeOpenStatus == "Close"){
            return true;
        }else if(!isEmptyVariable(endReviewUserId) && taskItem.currentReviewUserId==userDetails.userId && endReviewUserId==userDetails.userId){
            return false;
        }else{
            return !isEmptyVariable(taskItem.observationId)||taskItem.allowEdit==="N"?true:false  
        }
    }

    // Upload annexure
    uploadAnnexuresBackupIconClick = (assignmentTaskId,type,isEditable,assignmentTaskUserId) => {
        if (type === "Annexures") {
            this.setState({
                showSelectUploadAnnexureDialog: true,
                deleteReactivateId: assignmentTaskId,
                isBackup: false,
                isEditable:isEditable
            });
        } else if (type === "Backups") {
            this.setState({
                showSelectUploadAnnexureDialog: true,
                deleteReactivateId: assignmentTaskId,
                isBackup: true,
                isEditable:isEditable
            });
        } else if (type === "Comments") {
            this.setState({
                deleteReactivateId: assignmentTaskId,
                showReviewCommentsDialog: true,
                assignmentTaskUserId: assignmentTaskUserId,
                type: "Comment",
                isEditable:isEditable
            });
        }
    };

    handleSelectUploadAnnexureDialogClose = (reloadFlag) => {
        this.setState({
            showSelectUploadAnnexureDialog: false,
            isBackup: false,
            type: "",
            assignmentTaskUserId:"",
            isEditable:false
        },
        () => {
            if (reloadFlag === true) {
                this.getFollowUpTaskTab();
            }
        });
    };

    handleReviewCommentsDialogClose = (reloadFlag) => {
        let type = this.state.type;

        this.setState({
            showReviewCommentsDialog: false,
            deleteReactivateId: "",
            type: "",
            assignmentTaskUserId:"",
            isEditable:false
        });
    };

    generateScoreDropdown = (fieldItem,taskId) => {
        let step = 1;
        switch (fieldItem.decimalValue) {
          case "tenth":
            step = 0.1;
            break;
          case "quarter":
            step = 0.25;
            break;
          case "half":
            step = 0.5;
            break;
          case "any":
            step = 0.01; // show only whole numbers in popup
            break;
          default:
            step = 1;
        }
        // generate all possible values
        let values = [];
        let displayValue = 0;
        if(this.state.hasTaskTemplateScore){
            let selectedTemplatefieldId = this.state.selectedTaskTemplateFields.find(item => item.fieldType === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE)
            displayValue = this.state.taskTemplateValuesMap[taskId]?.[selectedTemplatefieldId.fieldId]?.["value"];
        }
        if(!isEmptyVariable(displayValue)){
            displayValue = displayValue;
        }
        const maxScore = this.state.hasTaskTemplateScore ? displayValue : fieldItem.maximumScore;

        for (let i = 0; i <= maxScore; i += step) {
          values.push(Number(i.toFixed(2)));
        }
        
        // Take Only first 9 values
        values = values.slice(0, 9);
        // Map the initial values using a ternary operator for cleaner logic
        const dropdownOptions = values.map(v => (
            fieldItem?.descriptions
                ? {
                    value: v,
                    description: `${v} - ${fieldItem.descriptions[v] || ""}`,
                    displayDescription: fieldItem.descriptions[v] || ""
                }
                : { value: v }
        ));

        // Create the 'N/A' option, conditionally adding description properties
        const naOption = {
            value: "N/A",
            ...(fieldItem?.descriptions && { description: "N/A", displayDescription: "N/A" })
        };

        // Append the 'N/A' option and return the final array
        return [...dropdownOptions, naOption];
    };

    renderSubTotal = (item, label) => {
        return this.renderTotalRow({
            label: label,
            itemList: item,
            isGrandTotal: false,
        });
    }

    renderGrandTotal = (idx) => {
        const { assignmentArea, datalist, filterDataList } = this.state;
        const dataSource = filterDataList.length > 0 ? filterDataList : datalist;
        const filteredData = dataSource.filter(item => !isEmptyArray(item.taskList));
        
        const shouldRender = assignmentArea !== "Function"
            ? idx === filteredData.length - 1
            : idx === (
                this.getProcessGroupingTaskList(filteredData, assignmentArea)
            ).length - 1;

        return this.renderTotalRow({
            label: 'Grand Total',
            itemList: filteredData,
            isGrandTotal: true,
            shouldRender
        });
    }
        
    renderTotalRow = ({label, itemList, isGrandTotal = false, shouldRender = true }) => {
        const numericFields = this.state.execTaskTemplateFields.filter(field =>
            field.fieldType === TemplateConstants.FIELD_TYPE_NUMERIC ||
            field.fieldType === TemplateConstants.FIELD_TYPE_VALUE_ADDITION ||
            field.fieldType === TemplateConstants.FIELD_TYPE_SCORE
        );
        let hasTaskTemplateScore = this.state.selectedTaskTemplateFields.some(f => f.fieldType === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE);
        let hasTaskTemplateWeightedScore = this.state.selectedTaskTemplateFields.some(f => f.fieldType === TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE);

        if (numericFields.length === 0 || !shouldRender) return null;
        return (
            <tr style={{fontWeight: "bold" }}>
                <td></td>
                <td></td>
                {
                    this.state.selectedTaskTemplateFields.map((item, taskIdx) => {
                        if(taskIdx === 0){
                            return(
                                <td style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                
                                {/* 2. Label Section: Apply a fixed width container */}
                                <div style={{ minWidth: '80px', marginRight: '30px' }} className="subtotal-container"> 
                                    {/* The width of 'Grand Total' is wider than 'Sub Total', so 120px should cover it */}
                                    {`${label}`}
                                    {!isGrandTotal &&
                                        <div className="tool info-tool" data-title="For entire sub-process / function.">
                                            <i className="material-icons icon-size">info</i>
                                        </div>
                                    }
                                </div>
                                
                                {/* 3. "Max possible Score" Label */}
                                {/* Use minWidth here too for perfect column alignment with the scores */}
                                <div style={{ marginRight: '20px' }}>
                                    Max possible Score
                                </div>

                                {/* 4. Scores Section: Displayed inline with a consistent gap */}
                                <div style={{ display: 'flex', gap: '20px' }}> 
                                    {this.state.execTaskTemplateFields.map(field => {
                                        if (field.fieldType === TemplateConstants.FIELD_TYPE_SCORE) {
                                            let ScoreFieldLength = this.state.execTaskTemplateFields.filter(f => f.fieldType === TemplateConstants.FIELD_TYPE_SCORE).length;
                                            const showFieldName = ScoreFieldLength > 1;
                                            
                                            const scoreValue = isGrandTotal
                                                ? this.state.totalScoreDetails?.grandTotalExecutionScore[field.fieldId]?.totalWeightedMaxScore
                                                : itemList?.subTotal?.executionScoreDetails[field.fieldId]?.totalWeightedMaxScore;

                                            // Conditionally construct the display string
                                            const displayString = showFieldName
                                                ? `${field.fieldName}: ${scoreValue}` // Shows "score: X"
                                                : `${scoreValue}`;   
                                            return(
                                                // Wrap the label and value in a span for a single score display
                                                <span key={field.fieldId}>
                                                    {field.isDecimalAllowed !== "N" &&
                                                        !isEmptyVariable(displayString)?displayString:""
                                                    }
                                                </span>
                                            )
                                        }
                                        return null;
                                    })}
                                </div>
                            </td>
                            )
                        }
                        if(item.fieldType === TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE){
                            return (
                                <td key={item.fieldId}>
                                    {(hasTaskTemplateScore && hasTaskTemplateWeightedScore) &&
                                        (isGrandTotal ? this.state.totalScoreDetails?.grandTotalWeightedScore : itemList?.subTotal?.totalWeightedMaxScore)
                                    }
                                </td>
                            )
                        }
                        else if(item.fieldType === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE){
                            return (
                                <td>
                                    {!hasTaskTemplateWeightedScore && 
                                        (isGrandTotal ? this.state.totalScoreDetails?.grandTotalScore : itemList?.subTotal?.totalMaxScore)
                                    }
                                </td> 
                            )
                        }
                        else{
                            return (
                                <td></td>
                            )
                        }
                    })
                }
                <td></td>
                <td></td>
                {this.state.isRisk && this.state.executionTemplateFixedFields?.assignRisk === "Y" &&
                hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) && this.state.isTemplateSettingRisk &&
                !isEmptyVariable(this.state.assignmentDetails.riskId) &&
                    <td></td>
                }
                {this.state.showWeight &&
                    <td></td>
                }
                {this.state.showYesNoDD &&
                    <td></td>
                }
                {this.state.showRanking &&
                    <td></td>
                }
                {this.state.execTaskTemplateFields.map(field => {
                    const isMultiSelect = field.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI ||
                      field.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT;
                    const shouldShowCell = !(isMultiSelect && field.isFromRiskMaster && field.isRiskMasterEnabled !== 'Y');
                    // Logic for Score Fields
                    if (field.fieldType === TemplateConstants.FIELD_TYPE_SCORE) {
                        // render the score and its optional description cell.
                        return (
                            <>
                                {/* {
                                    !this.state.hasTaskTemplateScore &&
                                    <td key={field.fieldId}></td>
                                } */}
                                {/* Cell for the score value */}
                                {field.isDecimalAllowed !== "N" &&
                                    <td key={field.fieldId}>
                                        {(() => {
                                            const source = isGrandTotal
                                                ? this.state.totalScoreDetails?.grandTotalExecutionScore[field.fieldId]
                                                : itemList?.subTotal?.executionScoreDetails[field.fieldId];

                                            if (!source) return "0/0.00%";

                                            const score = this.state.hasTaskTemplateWeightedScore
                                                ? source?.totalWeightedScore
                                                : source?.totalScore;

                                            const percentage = this.state.hasTaskTemplateWeightedScore
                                                ? source?.weightedPercentage
                                                : source?.percentage;

                                            return `${score || 0}/${!isEmptyVariable(percentage) ? percentage.toFixed(2) + "%" : "0.00%"}`;
                                        })()}
                                    </td>
                                }
                                {/* Optional second cell for a score description */}
                                {/* {field.isDecimalAllowed === "Y" && field?.descriptions &&
                                    <td key={`${field.fieldId}-desc`}></td>
                                } */}
                            </>
                        );
                    }

                    // Logic for Numeric and Value Addition Fields
                    else if (
                        field.fieldType === TemplateConstants.FIELD_TYPE_NUMERIC ||
                        field.fieldType === TemplateConstants.FIELD_TYPE_VALUE_ADDITION
                    ) {
                        // Render a single cell with the calculated total.
                        return (
                            <td key={field.fieldId}>
                                {(() => {
                                    const { sum, total, hasFloat } = isGrandTotal
                                        ? this.getGrandTotal(itemList, [field], this.state.executionTemplateValuesMap)
                                        : this.getFieldTypeSum(itemList.taskList, [field], this.state.executionTemplateValuesMap);
                                    const value = isGrandTotal ? total : sum;
                                    return (hasFloat && value % 1 !== 0) ? value.toFixed(2) : parseInt(value, 10);
                                })()}
                            </td>
                        );
                    }
                    // For any other field type, render an empty cell to maintain table alignment.
                    else {
                        return (
                            shouldShowCell &&(
                                <td key={field.fieldId}></td>
                            )
                        );
                    }
                })}
                {!isEmptyVariable(this.state.assignmentStatus) && 
                this.state.assignmentStatus === Constants.ASSIGNMENT_STATUS_COMPLETED &&
                    <td></td>
                }
            </tr>
        )
    }

    /*################################## EXEC TASK RELATED #################################*/
    getExecTableDataDisplayValue = (assignmentTaskId, fieldItem) => {
        if (isEmptyVariable(this.state.executionTemplateValuesMap[assignmentTaskId])) {
            return "";
        }

        let fieldId = fieldItem.fieldId;
        if (isEmptyVariable(this.state.executionTemplateValuesMap[assignmentTaskId][fieldId])) {
            return "";
        }

        let displayValue = this.state.executionTemplateValuesMap[assignmentTaskId][fieldId]["value"];
        if (isEmptyVariable(displayValue)) {
            return "";
        }

        switch (fieldItem.fieldType) {
            case TemplateConstants.FIELD_TYPE_TEXT:
                return removeHtmlTags(displayValue);
            case TemplateConstants.FIELD_TYPE_DATE:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_SINGLE_SELECT:
            case TemplateConstants.FIELD_TYPE_ISO:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_DROPDOWN:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_MULTI_SELECT:
                if (!isJsonString(displayValue)) {
                    return "";
                }
                return JSON.parse(displayValue).join(", ");
            case TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI:
                if (!isJsonString(displayValue)) {
                    return "";
                }
                return JSON.parse(displayValue).join(", ");
            case TemplateConstants.FIELD_TYPE_TABLE:
                if (!isJsonString(displayValue)) {
                    return "";
                }
                return JSON.parse(displayValue);
            case TemplateConstants.FIELD_TYPE_NUMERIC:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_VALUE_ADDITION:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_YES_NO:
                return displayValue;
            case TemplateConstants.FIELD_TYPE_SCORE:
                return displayValue;
        }
        return "";
    };

    getExecTableDataDisplayValueNR = (assignmentTaskId, fieldItem) => {
        if (isEmptyVariable(this.state.executionTemplateValuesMap[assignmentTaskId])) {
            return "";
        }

        let fieldId = fieldItem.fieldId;
        if (isEmptyVariable(this.state.executionTemplateValuesMap[assignmentTaskId][fieldId])) {
            return "";
        }

        let displayValue = this.state.executionTemplateValuesMap[assignmentTaskId][fieldId]["valueNR"];
        if (displayValue === "Y") {
            return "Y";
        }else{
            return "N"
        }
    };

    getExecTaskDisplayTableData = (assignmentTaskId, fieldItem, taskId, leafNodeId) => {
        switch (fieldItem.fieldType) { 
            case TemplateConstants.FIELD_TYPE_TEXT:
            case TemplateConstants.FIELD_TYPE_NUMERIC:
            case TemplateConstants.FIELD_TYPE_VALUE_ADDITION:
                return (
                    <td style={{height:"100%"}}>
                        <div
                            contenteditable={"false"}
                            onBlur={this.handleExecuteTextField.bind(
                                this,
                                assignmentTaskId,
                                fieldItem
                            )}
                            className="exec-task-text-field"
                        >
                            {this.getExecTableDataDisplayValue(assignmentTaskId, fieldItem)}
                        </div>
                    </td>
                );
            case TemplateConstants.FIELD_TYPE_DATE:
                let displayLabelDate = this.getExecTableDataDisplayValue(
                    assignmentTaskId,
                    fieldItem
                );
                return (
                    <td>
                        <DatePickerComponent
                            templateItemIndex={assignmentTaskId}
                            fieldItem={fieldItem}
                            onDateChange={this.onExecuteDateFieldChange}
                            placeholderValue={"Enter " + fieldItem.fieldName}
                            fieldValue={
                                !isEmptyVariable(displayLabelDate) ? displayLabelDate : ""
                            }
                            isDisabled={"Y"}
                        />
                    </td>
                );
            case TemplateConstants.FIELD_TYPE_SINGLE_SELECT:
            case TemplateConstants.FIELD_TYPE_ISO:
                let displayLabel = this.getExecTableDataDisplayValue(
                    assignmentTaskId,
                    fieldItem
                );
                let displayLabelNR = this.getExecTableDataDisplayValueNR(
                    assignmentTaskId,
                    fieldItem
                );
                return (
                    <td>{displayLabelNR == "Y"?"NA":displayLabel}</td>
                );
            case TemplateConstants.FIELD_TYPE_MULTI_SELECT:
            case TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI:
                let displayLabelMulti = this.getExecTableDataDisplayValue(
                    assignmentTaskId,
                    fieldItem
                );
                let displayLabelMultiNR = this.getExecTableDataDisplayValueNR(
                    assignmentTaskId,
                    fieldItem
                );
                return (
                    <td>{displayLabelMultiNR == "Y"?"NA":displayLabelMulti.includes('Other')?displayLabelMulti.replace('Other:-:', '').trim():displayLabelMulti}</td>
                );
            case TemplateConstants.FIELD_TYPE_TABLE:
                let parsedJsonTableObj = this.getExecTableDataDisplayValue(
                    assignmentTaskId,
                    fieldItem
                );
                let displayLabelTableNR = this.getExecTableDataDisplayValueNR(
                    assignmentTaskId,
                    fieldItem
                );
                return (
                    <td>
                        {
                            displayLabelTableNR == "Y"
                            ?"NA"
                            :(isEmptyVariable(parsedJsonTableObj) ? "-" : this.getAssignmentTaskExecTable(parsedJsonTableObj))
                        }
                    </td>
                );
            case TemplateConstants.FIELD_TYPE_YES_NO:
                let displayLabelYesNo = this.getExecTableDataDisplayValue(
                    assignmentTaskId,
                    fieldItem
                );
                // Use dropdown values from fieldItem
                const yesNoOptions = fieldItem.dropdownValues || [];
                return (
                    <td>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <RegularDropdown
                                placeholder={isEmptyVariable(displayLabelYesNo) ? "Select" : displayLabelYesNo}
                                dropdownArr={yesNoOptions}
                                labelParam="label"
                                onDropDownItemClick={(selectedItem) =>{}}
                                udf={assignmentTaskId + ":-:" + fieldItem.fieldId}
                                disabled={true}
                            />
                        </div>
                    </td>
                );
                case TemplateConstants.FIELD_TYPE_SCORE:
                const scoreValue = this.getExecTableDataDisplayValue(assignmentTaskId, fieldItem);
                const description = (fieldItem.isDecimalAllowed === "Y" && fieldItem?.descriptions)
                    ? this.generateScoreDropdown(fieldItem, taskId).find(item => String(item.value) === String(scoreValue))?.displayDescription
                    : null;
                    return(
                        <>
                            {fieldItem.isDecimalAllowed === "Y" &&
                                <td >
                                    <div className="score-cell">
                                        <span className="score-value">{scoreValue}</span>
                                        {(description && description !== "N/A") && <span> {description}</span>}
                                    </div>
                                </td>
                            }
                        </>
                    )   
        }
    };

    onExecuteDateFieldChange = (dateValue, assignmentTaskId, fieldItem) => {
        this.saveAssignmentTaskTemplateValues(assignmentTaskId,fieldItem,dateValue,{});
    };

    getFirstRowItemValue = (item,idx) => {
        let tempFirstRowList =["yes / no with disable","yes / no / na with disable","yes / no","yes / no / na","textfield"]
        if(idx==0)
        {
            if(!tempFirstRowList.includes(item.toLocaleLowerCase()) )
            {
                return item
            }
            
            else
            {
                return ""
            }
            
        }
        else if(idx!=0){
            return item
        }
       
    }

    getAssignmentTaskExecTable = (parsedJsonTableObj) => {
        return <table className="my-2">
            {
                Object.values(parsedJsonTableObj.tableArray).map((item, idx) => {
                    return <tr>
                        <td style={{ fontSize: 10, minwidth: "300px", Height: "22px" }}>{item[0]}</td>
                        <td style={{ fontSize: 10, minwidth: "300px", Height: "22px" }}>{this.getFirstRowItemValue(item[1],idx)}</td>
                    </tr>
                })
            }
        </table>
    }

    handleExecuteTextField = (assignmentTaskId, fieldItem, e) => {
        const value = e.currentTarget.textContent;
        let currentRemark = this.getExecTableDataDisplayValue(
            assignmentTaskId,
            fieldItem
        );

        if (currentRemark !== value) {
            this.saveAssignmentTaskTemplateValues(
                assignmentTaskId,
                fieldItem,
                value,
                {}
            );
        }
    };
    /*################################## EXEC TASK RELATED ENDS#################################*/

    /*******************API CALLS*******************/
    getInitData = () => {
        this.setState({
            showLoader: true,
        });

        Promise.all([
            fetch(Constants.GetFollowUpTaskTab, {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams({
                    email: userDetails.email,
                    accessToken: userDetails.accessToken,
                    assignmentId: this.state.assignmentId,
                    departmentId: this.state.departmentId,
                    forDraft: true
                }),
            }),
            fetch(Constants.GetDraftReportDetails, {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams({
                    email: userDetails.email,
                    accessToken: userDetails.accessToken,
                    assignmentId: this.state.assignmentId,
                    forDraft: true
                }),
            }),
            fetch(Constants.GetUserMenusForDraft, {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams({
                    email: userDetails.email,
                    accessToken: userDetails.accessToken,
                    assignmentId: this.state.assignmentId,
                    forDraft: true
                }),
            }),
        ])
        .then(([taskRes, assignmentRes, menuRes]) => {
            return Promise.all([
                taskRes.json(),
                assignmentRes.json(),
                menuRes.json()
            ]);
        })
        .then(([taskRes, assignmentRes, menuRes]) => {
            let allDatalistTemp = [];
            let myDatalistTemp = [];
            let assignmentStatus = "";
            let assignmentArea = "";
            let assignmentDetails = {};
            let deptDefaultRisk = taskRes.data.deptDefaultRisk ?? {};
            let singleSelectFilters = [];
            let singleSelectFiltersList = [];
            let allSettings = [];
            let isIndustryFlag = false;
            let likelihoodRiskMatrix = [];
            let hasTaskTemplateScore = false;
            let hasTaskTemplateWeightedScore = false;
            let totalScoreDetails = {}
            //Since we need assignment area lets check this first
            let selectedTaskTemplateFields = [];
            let execTaskTemplateFields = [];
            let taskTemplateValuesMap = {};
            let executionTemplateValuesMap = {};
            let executionTemplateFixedFields = {};
            let followUpTemplateFixedFields = {};
            let assignmentRiskMatrix = [];
            let valueAdditions = [];
            let userTemp = {};
            let menusTemp = {};

            if(handleTokenExpiry(assignmentRes.responseCode)) return;
            else if (assignmentRes.responseCode === Constants.CODE_SUCCESS) {
                assignmentDetails = assignmentRes.data.result;
                assignmentStatus = assignmentDetails.assignmentStatus;
                assignmentArea = assignmentDetails.assignmentArea;


                //TASK TEMPLATE RELATED STUFFS
                taskTemplateValuesMap = assignmentRes.data.taskTemplateValuesMap;
                let selectedTaskTemplateFieldsStr = assignmentRes.data.executionTemplateFields?.taskTemplateFields; //Template field IDs
                if (
                    !isEmptyVariable(selectedTaskTemplateFieldsStr) &&
                    isJsonString(selectedTaskTemplateFieldsStr)
                ) {
                    selectedTaskTemplateFields = JSON.parse(selectedTaskTemplateFieldsStr);
                }
                hasTaskTemplateScore = selectedTaskTemplateFields.some(f => f.fieldType === TemplateConstants.FIELD_TYPE_MAXIMUM_SCORE);
                hasTaskTemplateWeightedScore = selectedTaskTemplateFields.some(f => f.fieldType === TemplateConstants.FIELD_TYPE_WEIGHTED_SCORE);
                //EXEC TASK RELATED STUFFS
                executionTemplateValuesMap = assignmentRes.data.executionTemplateValuesMap;

                let execTaskTemplateFieldsStr = assignmentRes.data.executionTemplateFields?.templateFields;
                if (
                    !isEmptyVariable(execTaskTemplateFieldsStr) &&
                    isJsonString(execTaskTemplateFieldsStr)
                ) {
                    execTaskTemplateFields = JSON.parse(execTaskTemplateFieldsStr);
                }

                //EXEC TASK FIXED FIELDS
                let fixedTemplateFieldsStr = assignmentRes.data.executionTemplateFields?.fixedTemplateFields;
                if (
                    !isEmptyVariable(fixedTemplateFieldsStr) &&
                    isJsonString(fixedTemplateFieldsStr)
                ) {
                    executionTemplateFixedFields = JSON.parse(fixedTemplateFieldsStr);
                }

                //FOLLOWUP TASK FIXED FIELDS
                let followUpFixedTemplateFieldsStr = assignmentRes.data.followUpTemplateFields?.fixedTemplateFields;
                if (
                    !isEmptyVariable(followUpFixedTemplateFieldsStr) &&
                    isJsonString(followUpFixedTemplateFieldsStr)
                ) {
                    followUpTemplateFixedFields = JSON.parse(followUpFixedTemplateFieldsStr);
                }
                assignmentRiskMatrix = assignmentRes.data.riskLevels ?? [];
                valueAdditions = assignmentRes.data.valueAdditions;
                likelihoodRiskMatrix = assignmentRes.data.likelihoodLevels;
            } else {
            }

            let maxRank = 0;
            let showChecklistScores = false;
            let overallChecklistScoreObj = {};
            let assignmentChecklistObj = {};
            let matrixandMyDetails = {};
            let task = {};
            let annexureList = [];
            let isRisk = false;
            let isSampleChecked = false;
            let isLikelihood = false;
            let isTemplateSettingRisk = false;
            if(handleTokenExpiry(taskRes.responseCode)) return;
            else if (taskRes.responseCode === Constants.CODE_SUCCESS) {
                allDatalistTemp = taskRes.data.assignedTasks;
                totalScoreDetails = taskRes.data.totalScoreDetails;
                singleSelectFilters = taskRes.data.singleSelectFilters;
                let allDataList = JSON.parse(JSON.stringify(allDatalistTemp));
                annexureList = taskRes.data.annexureList;
                //if assignment area is checklist we may need to show scores in certain cases
                if (assignmentArea === "CheckList") {
                    assignmentChecklistObj = taskRes.data.assignmentCheckList;
                    overallChecklistScoreObj = taskRes.data.assignmentScore;
                    showChecklistScores = getCheckListScoresFlag(
                        assignmentChecklistObj.checkListType
                    );
                    if (showChecklistScores) {
                        maxRank = assignmentChecklistObj.maxRank;
                    }
                }

                //show only Selected User's/My tasks from the tasks list
                myDatalistTemp = getOnlyMyTasks(allDataList, assignmentArea, maxRank);
                //need list of users/reviewers
                let assignmentMatrixObj = taskRes.data.assignmentMatrix;

                //Get memberslist & Reviewers list for dropdown
                if(!isEmptyVariable(assignmentMatrixObj)){
                    matrixandMyDetails = getMatrixandMyDetails(assignmentMatrixObj);
                }
            } else {
            }

            if(handleTokenExpiry(menuRes.responseCode)) return;
            else if (menuRes.responseCode === Constants.CODE_SUCCESS) {
                userTemp = menuRes.data.user;
                allSettings = menuRes.data.allSettings;
                menusTemp = menuRes.data.menus;
                if(allSettings.find(item => item.settingDisplayColumn === Constants.SCREEN_INDUSTRY).settingColumnEnabled === "Y"){
                    isIndustryFlag = true;
                }
                isRisk = allSettings.some(e => e.settingColumn.includes(Constants.DISABLEDRISK) && e.settingColumnEnabled === "N" && 
                    e.departmentId === assignmentDetails.departmentId && e.assignmentTypeId === assignmentDetails.assignmentTypeId && e.rootTemplateId === assignmentDetails.rootTemplateId);
                isLikelihood = allSettings.some(e => e.settingColumn.includes(Constants.DISABLEDLIKELIHOOD) && e.settingColumnEnabled === "N" && 
                    e.departmentId === assignmentDetails.departmentId && e.assignmentTypeId === assignmentDetails.assignmentTypeId && e.rootTemplateId === assignmentDetails.rootTemplateId);
                isSampleChecked = allSettings.some(e => e.settingColumn.includes(Constants.DOCLIST) && e.settingColumnEnabled === "Y" && 
                    e.departmentId === assignmentDetails.departmentId && e.assignmentTypeId === assignmentDetails.assignmentTypeId && e.rootTemplateId === assignmentDetails.rootTemplateId);
                isTemplateSettingRisk = allSettings.some(e => e.settingColumn.includes(Constants.EXECUTION_TASK) && e.settingColumnEnabled === "Y" && 
                    e.departmentId === assignmentDetails.departmentId && e.assignmentTypeId === assignmentDetails.assignmentTypeId && e.rootTemplateId === assignmentDetails.rootTemplateId);
            } else {
            }

            //Lets check few things that are needed for checklist based assignment
            let showWeight = false;
            let showRanking = false;
            let showYesNoDD = false;
            let minRank = 0;
            let rankingArray = getRankingArray(minRank, maxRank);

            if (!isEmptyArray(allDatalistTemp) && assignmentArea === "CheckList") {
                let firstItem = allDatalistTemp[0];
                minRank = firstItem.taskList[0].minRank;

                if (!isEmptyArray(firstItem.taskList)) {
                    if (firstItem.taskList[0].checkListType === "WR") {
                        showWeight = true;
                        showRanking = true;
                    } else if (firstItem.taskList[0].checkListType === "R") {
                        showRanking = true;
                    } else if (firstItem.taskList[0].checkListType === "Y/N") {
                        showYesNoDD = true;
                    }
                }
            }

            let tempFilterArray = [
                {
                    label: "All",
                    isSelected: true,
                },
            ];

            Object.values(myDatalistTemp).map((item) => {
                let uid = 0;
                Object.values(item.taskList).map((task) => {
                    uid = task.userId;
                });

                if (uid === userDetails.userId) {
                    tempFilterArray.push({
                        label: assignmentArea === "Process" ? item.processName : assignmentArea === "Function" ? item.functionName : item.heading,
                        isSelected: false,
                    });
                }
            });


            //Set filter for single select
            Object.values(singleSelectFilters).forEach(item => {
                let tempSingleSelectItem = {};
                tempSingleSelectItem.fieldId = item.fieldId;
                tempSingleSelectItem.fieldName = item.fieldName;
                let tempSingleSelectArr = [
                    {
                        label: "All",
                        isSelected: true
                    },
                    {
                        label:"NA",
                        isSelected: false
                    }
                ];
                Object.values(item.dropdownValues).map(dropdownItem => {
                    tempSingleSelectArr.push({
                        label: dropdownItem.value,
                        isSelected: false
                    })
                })
                tempSingleSelectItem.dropdownValues = tempSingleSelectArr;
                tempSingleSelectItem.placeholderValue = "";
                singleSelectFiltersList.push(tempSingleSelectItem);
            });

            //Risk Level
            let riskObj = {
                riskLevelId: deptDefaultRisk?.[assignmentDetails.departmentId]?.riskLevelId ?? "",
                riskLevel: deptDefaultRisk?.[assignmentDetails.departmentId]?.riskLevel ?? "",
            };
            task = {
                selectedRiskObj: riskObj
            }

            this.setState({
                componentDidMountFlag: true,
                showLoader: false,
                datalist: myDatalistTemp,
                allDatalist: allDatalistTemp,
                
                selectedTaskTemplateFields: selectedTaskTemplateFields,
                taskTemplateValuesMap: taskTemplateValuesMap,
                execTaskTemplateFields: execTaskTemplateFields,
                executionTemplateValuesMap: executionTemplateValuesMap,
                executionTemplateFixedFields: executionTemplateFixedFields,
                followUpTemplateFixedFields:followUpTemplateFixedFields,
                assignmentRiskMatrix: assignmentRiskMatrix,
                valueAdditions: valueAdditions,

                assignmentStatus: assignmentStatus,
                assignmentArea: assignmentArea,
                assignmentDetails: assignmentDetails,
                assignmentMatrix: matrixandMyDetails.assignmentMatrix,
                selectedResourceUserName: matrixandMyDetails.selectedResourceUserName,
                selectedResourceId: userDetails.userId,
                myPosition: matrixandMyDetails.myPosition,
                
                showWeight: showWeight,
                showRanking: showRanking,
                showYesNoDD: showYesNoDD,
                checklistMaxRank: maxRank,
                showChecklistScores: showChecklistScores,
                overallChecklistScoreObj: overallChecklistScoreObj,
                rankingArray: rankingArray,
                filterDropDownArr: tempFilterArray,

                singleSelectDropDownArr:singleSelectFiltersList,
                allAnnexureList:annexureList,
                user: userTemp,
                allSettings:allSettings,
                isIndustryFlag:isIndustryFlag,
                ...task,
                deptDefaultRisk:deptDefaultRisk,
                likelihoodRiskMatrix: likelihoodRiskMatrix,
                isRisk:isRisk,
                isLikelihood:isLikelihood,
                isSampleChecked:isSampleChecked,
                menu:menusTemp,
                hasTaskTemplateScore:hasTaskTemplateScore,
                hasTaskTemplateWeightedScore:hasTaskTemplateWeightedScore,
                totalScoreDetails:totalScoreDetails,
                isTemplateSettingRisk:isTemplateSettingRisk
            });
        });
    };

    getProcessGroupingTaskList = (Datalist, assignmentArea) => {
        if (assignmentArea === "Function") {
            let tempProcessList = [];
            let processName = [];
            let tempAllDataList = Object.values(Datalist);
            Object.values(Datalist).map((item) => {
                Object.values(item.taskList).map((task) => {
                    if (!processName.includes(task.processNameList)) {
                        processName.push(task.processNameList)
                    }
                })
            })

            tempAllDataList.map((item) => {
                let tempTaskList = [];
                tempProcessList = [];
                let tempItem = item;
                let tempProcessId = "";
                processName.map((process) => {
                    tempTaskList = [];
                    Object.values(item.taskList).map((task) => {
                        tempProcessId = task.processIdList
                        if (task.processNameList === process) {
                            tempTaskList.push(task)
                        }
                    })

                    tempProcessList.push({
                        processName: process,
                        functionName: item.functionName,
                        processId: tempProcessId,
                        taskList: tempTaskList
                    })
                    tempItem["processTaskList"] = tempProcessList
                })
            })
            return tempAllDataList
        }
        else {
            return Datalist
        }
    }

    getFollowUpTaskTab = () => {
        this.setState({
            showLoader: true,
        });

        fetch(Constants.GetFollowUpTaskTab, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                assignmentId: this.state.assignmentId,
                departmentId: this.state.departmentId
            }),
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                let assignmentChecklistObj = {};
                let overallChecklistScoreObj = {};
                let totalScoreDetails = data.data.totalScoreDetails;
                let allDatalistTemp = data.data.assignedTasks;
                let allDataList = JSON.parse(JSON.stringify(allDatalistTemp));

                let maxRank = 0;
                if (this.state.assignmentArea === "CheckList") {
                    assignmentChecklistObj = data.data.assignmentCheckList;
                    overallChecklistScoreObj = data.data.assignmentScore;

                    if (
                        assignmentChecklistObj.checkListType === "Y/N" ||
                        assignmentChecklistObj.checkListType === "WR" ||
                        assignmentChecklistObj.checkListType === "R"
                    ) {
                        maxRank = assignmentChecklistObj.maxRank;
                    }
                }

                //show only Selected User's/My tasks
                let myDatalistTemp = allDataList.map((process) => {
                    let taskList = [];
                    let maxScore = 0;
                    let totalScore = 0;
                    process.taskList.forEach((task) => {
                        if (task.userId + "" === this.state.selectedResourceId + "") {
                            taskList.push(task);

                            //Now if it is checklist, then based on the type of checklist we need to assign scores
                            if (this.state.assignmentArea === "CheckList") {
                                let weight = isEmptyVariable(task.weight) ? 1 : task.weight;
                                let rank =
                                    isEmptyVariable(task.rank) || task.rank === -1
                                        ? 0
                                        : task.rank;

                                let maxRankNew = task.rank === -1 ? 0 : maxRank;
                                maxScore += weight * maxRankNew;
                                totalScore += weight * rank;
                            }
                        }
                    });
                    process.taskList = taskList;
                    process.maxScore = maxScore;
                    process.totalScore = totalScore;
                    return process;
                });

                this.setState({
                    showLoader: false,
                    datalist: myDatalistTemp,
                    allDatalist: allDatalistTemp,
                    overallChecklistScoreObj: overallChecklistScoreObj,
                    totalScoreDetails:totalScoreDetails
                });
            } else {
                this.setState({
                    datalist: [],
                    showLoader: false,
                });
            }
        });
    };

    getAssignmentDetails = (resetStateValues) => {
        this.setState({
            showLoader: true,
        });

        fetch(Constants.GetDraftReportDetails, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                assignmentId: this.state.assignmentId,
                forDraft: true
            }),
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                let executionTemplateValuesMap = data.data.executionTemplateValuesMap;
                let executionTemplateFixedFields = {};
                let followUpTemplateFixedFields = {};
                let fixedTemplateFieldsStr = data.data.executionTemplateFields?.fixedTemplateFields;
                if (
                    !isEmptyVariable(fixedTemplateFieldsStr) &&
                    isJsonString(fixedTemplateFieldsStr)
                ) {
                    executionTemplateFixedFields = JSON.parse(fixedTemplateFieldsStr);
                }
                //FOLLOWUP TASK FIXED FIELDS
                let followUpFixedTemplateFieldsStr = data.data.followUpTemplateFields?.fixedTemplateFields;
                if (
                    !isEmptyVariable(followUpFixedTemplateFieldsStr) &&
                    isJsonString(followUpFixedTemplateFieldsStr)
                ) {
                    followUpTemplateFixedFields = JSON.parse(followUpFixedTemplateFieldsStr);
                }
                this.setState({
                    executionTemplateValuesMap: executionTemplateValuesMap,
                    executionTemplateFixedFields: executionTemplateFixedFields,
                    followUpTemplateFixedFields: followUpTemplateFixedFields,
                    showLoader: false,
                    ...resetStateValues,
                });
            } else {
            }
        });
    };

    handleRecordOperation = () => {
        let url = "";
        let postParam = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            forDraft: true
        };
        let callApi = true;

        if(this.state.operationType === "Follow Up Details"){
            url = Constants.GetPreviousFollowUpTaskTemplateValues;
            postParam.assignmentTaskId = this.state.deleteReactivateId;
        }else if (this.state.operationType === "Submit For Review"){
            url = Constants.SubmitFollowUpTaskForReview;
            postParam.assignmentTaskId = this.state.deleteReactivateId;
        }else if(this.state.operationType === "Start Review"){
            url = Constants.UpdateFollowUpTaskReviewStatus;
            postParam.reviewLevel = this.state.reviewLevel;
            postParam.reviewStatus = Constants.REVIEW_STATUS_STARTED;
        }else if(this.state.operationType === "Update Review Status"){
            url = Constants.UpdateFollowUpTaskReviewStatus;
            postParam.assignmentTaskId = this.state.deleteReactivateId;
            postParam.reviewLevel = this.state.reviewLevel;
            postParam.reviewStatus = Constants.REVIEW_STATUS_APPROVED;
            if (!isEmptyVariable(this.state.remarks)) {
                postParam.remark = this.state.remarks;
            } else {
                postParam.remark = "";
            }
        }else if(this.state.operationType === "CloseFollowUp"){
            callApi = false;
            this.getFollowupTaskTemplatevalues(this.state.deleteReactivateId,true);
            this.setState({
                showFollowUpTemplateValueDialog:true,
                isFollowUpTemplateValueEditDialog:false
            })
        }

        if (callApi) {
            this.setState({
                showBtnLoader: true,
            });

            fetch(url, {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams(postParam),
            })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if(handleTokenExpiry(data.responseCode)) return;
                else if (data.responseCode === Constants.CODE_SUCCESS) {
                    this.setState({
                        deleteReactivateId: "",
                        deleteReactivateMasterType: "",
                        operationType: "",
                        alertDialogHeading: "",
                        proceedBtnLabel: "",
                        alertDialogMessage: "",
                        showAlertDialog: false,
                        remarks: "",
                        showBtnLoader: false
                    },() => {
                        this.getFollowUpTaskTab();
                    });
                } else {
                    this.setState({
                        showBtnLoader: false,
                        deleteReactivateId: "",
                        deleteReactivateMasterType: "",
                        operationType: "",
                        alertDialogHeading: "",
                        proceedBtnLabel: "",
                        alertDialogMessage: "",
                        showAlertDialog: false,
                        showAlertDialogInfo: true,
                        alertDialogMessageInfo: data.responseMessage,
                        remarks: "",
                    });
                }
            });
        }
    };

    getPreviousFollowUpTaskTemplateValues = (assignmentTaskId,observationId,item) => {
        let postParam = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            forDraft: true
        }
        if(isEmptyVariable(observationId)){
            postParam.assignmentTaskId = assignmentTaskId;
        }else{
            postParam.observationId = observationId;
        }
        fetch(Constants.GetPreviousFollowUpTaskTemplateValues, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams(postParam),
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                const previousCheckAndOpen = data.data.previousCheckAndOpen;
                this.handleFollowUpDetailsDialogShow(previousCheckAndOpen,assignmentTaskId,item);
            } else {
                this.setState({
                    showFollowUpDetailsDialog:false
                });
            }
        });
    }

    handleSaveAssignmentTaskProperties = (assignmentTaskId,remark,fieldName) => {
        let postParam = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            assignmentId: this.state.assignmentId,
            assignmentTaskId: assignmentTaskId,
            [fieldName]: remark,
            forDraft: true
        };
        if (fieldName === "remark") {
            postParam.type = "Remark";
        }

        fetch(Constants.SaveAssignmentTaskProperties, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams(postParam),
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                this.setState({}, () => {
                    this.getFollowUpTaskTab();
                });
            } else {
            }
        });
    };

    saveAssignmentTaskTemplateValues = (assignmentTaskId,fieldItem,value,resetStateValues,valueNR) => {
        let postObj = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            assignmentTaskId: assignmentTaskId,
            fieldId: fieldItem.fieldId,
            fieldType: fieldItem.fieldType,
            [fieldItem.fieldId]: value,
            forDraft: true
        }

        if(valueNR === "Y"){
            postObj[fieldItem.fieldId+"_NR"] = "Y";
        }

        fetch(Constants.SaveAssignmentTaskTemplateValues, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams(postObj),
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                this.getAssignmentDetails(resetStateValues);
            } else {
            }
        });
    };

    getFollowupTaskTemplatevalues = (assignmentTaskId,reloadFlag) => {
        this.setState({
			showLoader: true,
		});

        fetch(Constants.GetFollowUpTaskTemplateValues, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                assignmentTaskId: assignmentTaskId,
                forDraft: true
            }),
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                let followUpTaskTemplateLists = data.data?.templateFields;
                let fixedTemplateFields = data.data?.fixedTemplateFields;

                this.setState({
                    followUpTaskTemplateList: followUpTaskTemplateLists,
                    fixedTemplateFields:fixedTemplateFields,
                    assignmentTaskId: assignmentTaskId,
                    showLoader: false,
                })
                if(reloadFlag === true){
                    this.setState({
                        showAlertDialog:false,
                        alertDialogHeading:"",
                        alertDialogMessage:"",
                        proceedBtnLabel:"",
                        operationType:"",
                        deleteReactivateId:""
                    })
                }
            } else {
                this.setState({
                    showLoader: false,
                });
            }
        });
    }

    getAllAnnexureList = (taskItem) => {
        let tempObj ={}; 
        tempObj.assignmentTaskId = taskItem.assignmentTaskId;
        let  url = Constants.GetAssignmentTaskAnnexures;
        return fetch(url, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams({
              email: userDetails.email,
              accessToken: userDetails.accessToken,
              assignmentTaskId:taskItem.assignmentTaskId,
              forDraft: true
            }),
        })
        .then((response) => {
            return response.json();
        }).then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                tempObj.annexureList = data.data.annexures
                this.state.allAnnexureList.push(tempObj)
            } 
        })
    }

    /*******************API CALLS END HERE*******************/
    
    render() {
        let showEmptyCard = true;
        return (
            <Router>
                <main className="main-dashboard">
                    <section className="dashboard-bg">
                        <Sidebar />
                        <div className="dashboard-right-bg-collpase">
                            <div className="dashboard-wrapper">
                                <Topbar />
                                {
                                    this.state.componentDidMountFlag && this.state.isShowHeader && (
                                    <FollowupHeading
                                        assignmentId={this.state.assignmentId}
                                        assignmentDetails={this.state.assignmentDetails}
                                        assignmentMatrix={this.state.assignmentMatrix}
                                        userDetails ={userDetails}
                                        selectedResourceId={this.state.selectedResourceId}
                                        themeSettings={themeSettings}
                                        isSampleChecked={this.state.isSampleChecked}
                                    />
                                )}
                                {
                                    this.state.showLoader && (
                                        <div class="loader"></div>
                                )}
                                {
                                    this.state.isShowHeader &&
                                    <div className="exe-followup-resource-dd flex-center-layout">
                                        {!isEmptyVariable(this.state.observationTemplateId) &&
                                            <div style={{ marginRight: 10 }}>
                                                <FilterDropDown
                                                    placeholder={this.state.observationTaskFilterPlaceholder}
                                                    dropdownArr={this.state.observationTaskFilterDropDownArr}
                                                    onDropDownItemClick={this.taskFilterDropDownOnClicks}
                                                    themeSettings={themeSettings}
                                                    name={"label"}
                                                    dropdownWidth="200px"
                                                />
                                            </div>
                                        }
                                        {!isEmptyArray(this.state.singleSelectDropDownArr) && this.state.singleSelectDropDownArr.map(item => {
                                            return(
                                                <div style={{ marginRight: 30 }}>
                                                    <FilterDropDown
                                                        placeholder={isEmptyVariable(item.placeholderValue)?item.fieldName:item.placeholderValue}
                                                        dropdownArr={item.dropdownValues}
                                                        onDropDownItemClick={this.singleSelectFilterDropDownOnClick.bind(this,item.fieldId)}
                                                        themeSettings={themeSettings}
                                                        name={"label"}
                                                        dropdownWidth="200px"
                                                    />
                                                </div>
                                            )
                                        })}
                                        
                                        <div style={{ marginRight: 30 }}>
                                            <FilterDropDown
                                                placeholder={this.state.filterPlaceholder=="All"?this.state.assignmentArea:this.state.filterPlaceholder}
                                                dropdownArr={this.state.filterDropDownArr}
                                                onDropDownItemClick={this.filterDropDownOnClick}
                                                themeSettings={themeSettings}
                                                name={"label"}
                                                dropdownWidth="200px"
                                            />
                                        </div>
                                        {
                                            (this.state.myPosition === "Viewer" ||
                                            this.state.myPosition === "Reviewer") && (
                                                <div style={{width:"200px", marginRight: 30}}>
                                                    <RegularDD
                                                        placeholder={this.state.selectedResourceUserName}
                                                        dropdownArr={this.state.assignmentMatrix}
                                                        labelParam="label"
                                                        onDropDownItemClick={this.resourceDropdownItemClick}
                                                    />
                                                </div>
                                            )
                                        }
                                    </div>
                                }

                                {
                                    // Need to check component did mount flag, other wise until api is called,
                                    // it shows no items found layout.
                                    this.state.componentDidMountFlag && 
                                    !this.state.showTaskDetailsLayout && (
                                        <div className="body-wrapper common-table-scroll">
                                            {
                                                !isEmptyArray(this.state.datalist) && this.state.assignmentArea !== "Function" &&
                                                (this.state.filterDataList.length > 0 ? this.state.filterDataList : this.state.datalist).map((item, index) => {
                                                    return (
                                                        !isEmptyArray(item.taskList) && (
                                                            <div>
                                                                <h6 style={{ marginTop: index === 0 ? 15 : 10 }} className="small-h6">
                                                                    {isEmptyVariable(item.processName) ? isEmptyVariable(item.functionName) ? item.heading : item.functionName : item.processName}
                                                                </h6>
                                                                {
                                                                    !isEmptyArray(item.taskList) && (
                                                                    <div>
                                                                        <div className="common-tab-bg">
                                                                            <div className="common-table" style={{ width: "100%" }} >
                                                                                <table className="table">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th className="text-center" width="38px"> No.</th>
                                                                                            <th width="1%">
                                                                                                <div className="flex-center-layout justify-content-around">
                                                                                                    {hasFeatureAccess(Constants.FEATURE_EXECUTE_COMMENTS) &&
                                                                                                        <span className="tool" data-title="Comments">C</span>
                                                                                                    }
                                                                                                    {this.state.executionTemplateFixedFields?.annexures === "Y" && (
                                                                                                        <span className="tool" data-title="Annexure">A</span>
                                                                                                    )}
                                                                                                    {this.state.followUpTemplateFixedFields?.backups === "Y" && (
                                                                                                        <span className="tool" data-title="Backups">B</span>
                                                                                                    )}
                                                                                                    {hasFeatureAccess(Constants.FEATURE_EXECUTE_PREVIOUS_OBSERVATION) &&
                                                                                                        <span className="tool" data-title="History">H</span>
                                                                                                    }
                                                                                                </div>
                                                                                            </th>
                                                                                            {
                                                                                                this.state.selectedTaskTemplateFields.map((item) => {
                                                                                                    return (
                                                                                                        <th className={item.fieldType === TemplateConstants.FIELD_TYPE_TEXT ? 
                                                                                                        "scrollable-table-task-text-th" : "scrollable-table-task-others-th"}>
                                                                                                            {item.fieldName}
                                                                                                        </th>
                                                                                                    );
                                                                                                }
                                                                                            )}
                                                                                            <th style={{minWidth:"150px"}}>Follow Up Date</th>      
                                                                                            <th></th>
                                                                                            {/* {
                                                                                                this.state.isRisk && !isEmptyVariable(this.state.assignmentDetails.riskId) &&
                                                                                                <th>Follow Up Risk</th>
                                                                                            } */}
                                                                                            {
                                                                                                this.state.isRisk && this.state.executionTemplateFixedFields?.assignRisk === "Y" &&
                                                                                                hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) && this.state.isTemplateSettingRisk &&
                                                                                                !isEmptyVariable(this.state.assignmentDetails.riskId) && 
                                                                                                <th>Risk</th>
                                                                                            }
                                                                                            {
                                                                                                this.state.showWeight &&
                                                                                                <th>Weight</th>
                                                                                            }
                                                                                            {
                                                                                                this.state.showYesNoDD &&
                                                                                                <th>Rating</th>
                                                                                            }
                                                                                            {
                                                                                                this.state.showRanking && 
                                                                                                <th>Rating</th>
                                                                                            }
                                                                                            {
                                                                                                this.state.execTaskTemplateFields.map(item => {
                                                                                                    let showHeader = true;
                                                                                                    if (item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI ||
                                                                                                        item.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT) {
                                                                                                        if (item.isFromRiskMaster) {
                                                                                                            if (item.isRiskMasterEnabled === "Y") {
                                                                                                                showHeader = true;
                                                                                                            } else {
                                                                                                                showHeader = false;
                                                                                                            }
                                                                                                        } else {
                                                                                                            showHeader = true;
                                                                                                        }
                                                                                                    }
                                                                                                    let scoreHeading = true;
                                                                                                    return (
                                                                                                        <>
                                                                                                        {showHeader && 
                                                                                                        <>
                                                                                                            {scoreHeading &&
                                                                                                                <th className={item.fieldType === TemplateConstants.FIELD_TYPE_TEXT
                                                                                                                    ? "scrollable-table-task-text-th" : "scrollable-table-task-others-th"}>
                                                                                                                    {item.fieldName}
                                                                                                                    {item.isMandatorySelected === "Y" ? "*" : ""}
                                                                                                                </th>
                                                                                                            }
                                                                                                        </>
                                                                                                        }
                                                                                                    </>
                                                                                                    )}
                                                                                                )
                                                                                            }
                                                                                            {/* {
                                                                                                hasFeatureAccess(Constants.FEATURE_OBSERVATION) &&
                                                                                                !isEmptyVariable(this.state.assignmentDetails.observationTemplateId) &&
                                                                                                <th>Observation</th>
                                                                                            } */}
                                                                                            {
                                                                                                !isEmptyVariable(this.state.assignmentStatus) && 
                                                                                                this.state.assignmentStatus === Constants.ASSIGNMENT_STATUS_COMPLETED &&
                                                                                                <th className="text-center"></th>
                                                                                            }
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {
                                                                                            !isEmptyArray(item.taskList) &&
                                                                                            item.taskList.map((taskItem, idx) => {
                                                                                                if(taskItem.annexureCount>0)
                                                                                                {
                                                                                                    // this.getAllAnnexureList(taskItem);
                                                                                                }
                                                                                                showEmptyCard = false;
                                                                                                let yNRank = defaultYNPlaceholder;
                                                                                                let isAuditeeResponse = this.state.menu[Constants.SCREEN_RESPONSE_TEMPLATE] === "ALL" && taskItem.auditeeResponseCount !== 0;
                                                                                                let actionObj = getFollowUpTasks(taskItem, this.state.assignmentDetails?.reviewAssignmentTask, isAuditeeResponse);
                                                                                                if(!isEmptyVariable(taskItem.observationId)){
                                                                                                    actionObj["actionArr"]=actionObj.actionArr.filter(e => ["Follow Up Details","Auditee Response","Review History"].includes(e.label))
                                                                                                }
                                                                                                // For Y/N, get label from yesNoRankArr
                                                                                                if (this.state.showYesNoDD && !isEmptyVariable(taskItem.rank)) {
                                                                                                    Constants.yesNoRankArr.forEach((rankItem) => { 
                                                                                                        if (taskItem.rank === rankItem.id) { 
                                                                                                            yNRank = rankItem.label; 
                                                                                                        } 
                                                                                                    });
                                                                                                }
                                                                                                
                                                                                                return (
                                                                                                    <tr style={{ background: this.taskEditable(taskItem)? "#f5f5f5" : "#ffffff", height:"40px"}}>
                                                                                                        <td className="text-center"> 
                                                                                                            {(this.state.currentPageNo - 1) * this.state.resultSize + (idx + 1)}
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            <div className="flex-center-layout exec-task-indicators">
                                                                                                                {hasFeatureAccess(Constants.FEATURE_EXECUTE_COMMENTS) &&
                                                                                                                    <div className="review-comment-layout">
                                                                                                                        <span className="material-icons" style={{
                                                                                                                            color: taskItem.remarkCount === 0 ? "#777777" : `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                                                                                                                            opacity: taskItem.remarkCount === 0 ? "0.6" : "1",
                                                                                                                        }}
                                                                                                                        onClick={this.uploadAnnexuresBackupIconClick.bind(this, taskItem.assignmentTaskId, "Comments", this.taskEditable(taskItem), taskItem.userId)}
                                                                                                                        >
                                                                                                                            chat
                                                                                                                        </span>
                                                                                                                        {taskItem.newRemarkCount && taskItem.newRemarkCount != 0 && (
                                                                                                                            <div class="review-comment-badge">
                                                                                                                                <span>{taskItem.newRemarkCount}</span>
                                                                                                                            </div>
                                                                                                                        )}
                                                                                                                    </div>
                                                                                                                }
                                                                                                                {this.state.executionTemplateFixedFields?.annexures === "Y" && (
                                                                                                                    <span className="material-icons" 
                                                                                                                    style={{
                                                                                                                        color: taskItem.annexureCount === 0 ? "#777777" : `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                                                                                                                        opacity: taskItem.annexureCount === 0 ? "0.6" : "1"
                                                                                                                    }}
                                                                                                                    onClick={this.uploadAnnexuresBackupIconClick.bind(this, taskItem.assignmentTaskId, "Annexures", this.taskEditable(taskItem))}
                                                                                                                    >
                                                                                                                        file_present
                                                                                                                    </span>
                                                                                                                )}
                                                                                                                {this.state.followUpTemplateFixedFields?.backups === "Y" && (
                                                                                                                    <span className="material-icons" style={{ 
                                                                                                                        color: taskItem.FollowUpBackupCount === 0 ? "#777777" : `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                                                                                                                        opacity: taskItem.FollowUpBackupCount === 0 ? "0.6" : "1"
                                                                                                                    }}
                                                                                                                    onClick={this.uploadAnnexuresBackupIconClick.bind(this, taskItem.assignmentTaskId, "Backups", this.taskEditable(taskItem), taskItem.userId)}>
                                                                                                                        cloud_upload
                                                                                                                    </span>
                                                                                                                )}
                                                                                                                {hasFeatureAccess(Constants.FEATURE_EXECUTE_PREVIOUS_OBSERVATION) &&
                                                                                                                    <span
                                                                                                                        className="material-icons"
                                                                                                                        style={{ color: "#777777", opacity: "0.6" }}
                                                                                                                        onClick={this.previousAssignmentData.bind(this,taskItem, this.state.assignmentArea == "CheckList" ? item.checkListHeadingId : item.processId)}>
                                                                                                                        manage_search
                                                                                                                    </span>
                                                                                                                }
                                                                                                            </div>
                                                                                                        </td>
                                                                                                        {
                                                                                                            this.state.selectedTaskTemplateFields.map((item, taskIdx) => {
                                                                                                                const isFramework = item.fieldType === TemplateConstants.FIELD_TYPE_FRAMEWORK;
                                                                                                                const isText = item.fieldType === TemplateConstants.FIELD_TYPE_TEXT;
                                                                                                                const taskDisplayValues = this.getTaskDisplayValues(taskItem.taskId, item);                                                                                                          
                                                                                                                return (
                                                                                                                    <td onClick={((isFramework || isText) && hasFeatureAccess(Constants.FEATURE_ON_CLICK_TASK_DETAILS)) ? 
                                                                                                                        this.handleShowTaskDetailsLayout.bind(this, taskItem.taskId) : null} 
                                                                                                                        style={taskIdx + "" === "0" ? { borderLeft: "5px solid " + (taskItem.fatal==="Y"?"#FF0000":taskItem.colorCode) } : {}} >
                                                                                                                        <div className={item.fieldId + "" === "1" ? "dangerouslysethtml-flex" : ""}>
                                                                                                                            {isFramework ? (
                                                                                                                                <div className="task-framework-list">
                                                                                                                                    {taskDisplayValues}
                                                                                                                                </div>
                                                                                                                            ) : (
                                                                                                                                <div 
                                                                                                                                    className={`task-dangerouslysethtml`} 
                                                                                                                                    dangerouslySetInnerHTML={{ __html: taskDisplayValues }} 
                                                                                                                                />
                                                                                                                            )}
                                                                                                                            {
                                                                                                                                taskItem.completionStatus === "Completed" && item.fieldId + "" === "1" && (
                                                                                                                                    <span className="material-icons exec-task-done" >
                                                                                                                                        done_all
                                                                                                                                    </span>
                                                                                                                                )
                                                                                                                            }
                                                                                                                        </div>
                                                                                                                    </td>
                                                                                                                );
                                                                                                            }
                                                                                                        )}
                                                                                                        <td>
                                                                                                            {
                                                                                                                isEmptyVariable(taskItem.followUpDate)?"":moment(taskItem.followUpDate).format("DD/MM/YYYY")
                                                                                                            }
                                                                                                        </td>
                                                                                                        <td style={{minWidth:"180px"}}>
                                                                                                            <RegularDD
                                                                                                                placeholder={isEmptyVariable(taskItem.closeOpenStatus)?this.state.filterOpenClosePlaceholder:taskItem.closeOpenStatus}
                                                                                                                dropdownArr={this.state.filterOpenCloseDropDownArr}
                                                                                                                labelParam="label"
                                                                                                                onDropDownItemClick={this.filterOpenCloseDropDownOnClick.bind(this,taskItem)}
                                                                                                                disabled={this.taskEditable(taskItem)}
                                                                                                            />
                                                                                                        </td>
                                                                                                        {/* {
                                                                                                            !isEmptyVariable(this.state.assignmentDetails.riskId) && 
                                                                                                            <td style={{minWidth:"120px"}}>
                                                                                                                {
                                                                                                                    isEmptyVariable(taskItem.followUpRiskLevel)?
                                                                                                                    <div className="risk-level-color-wrapper" style={{ width: "110px",height:"30px", marginLeft:0 }} 
                                                                                                                        onClick={this.taskEditable(taskItem)?null:
                                                                                                                        this.handleSelectRiskDialogShow.bind(this,taskItem)}/> :
                                                                                                                    <div onClick={this.taskEditable(taskItem)? null :
                                                                                                                        this.handleSelectRiskDialogShow.bind(this,taskItem)}>
                                                                                                                        {isEmptyVariable(taskItem.followUpRiskLevel)?"":taskItem.followUpRiskLevel}
                                                                                                                    </div>
                                                                                                                }
                                                                                                            </td>
                                                                                                        } */}
                                                                                                        {
                                                                                                            this.state.isRisk && this.state.executionTemplateFixedFields?.assignRisk === "Y" && this.state.isTemplateSettingRisk &&
                                                                                                            hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) && !isEmptyVariable(this.state.assignmentDetails.riskId) &&
                                                                                                            <td>
                                                                                                                {
                                                                                                                    (() => {
                                                                                                                        const showRisk = hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) && !isEmptyVariable(this.state.assignmentDetails.riskId);
                                                                                                                        const showLikelihood = this.state.isLikelihood && hasFeatureAccess(Constants.FEATURE_MATRIX_LIKELIHOOD) && !isEmptyVariable(this.state.assignmentDetails.likelihoodId);
                                                                                                                        const risk = showRisk ? (isEmptyVariable(taskItem.assignmentTaskRiskLevel) ? "" : taskItem.assignmentTaskRiskLevel) : "";
                                                                                                                        const likelihood = showLikelihood ? (isEmptyVariable(taskItem.assignmentTaskLikelihoodLevel) ? "" : taskItem.assignmentTaskLikelihoodLevel) : "";
                                                                                                                        if (showRisk && showLikelihood) {
                                                                                                                            if (risk && likelihood) {
                                                                                                                                return risk + " / " + likelihood;
                                                                                                                            } else if(!risk && !likelihood){
                                                                                                                                return "";
                                                                                                                            } else {
                                                                                                                                return risk +" / " + likelihood;
                                                                                                                            }
                                                                                                                        } else if (showRisk && risk) {
                                                                                                                            return risk;
                                                                                                                        } else if (showLikelihood && likelihood) {
                                                                                                                            return " / " + likelihood;
                                                                                                                        } else {
                                                                                                                            return "";
                                                                                                                        }
                                                                                                                    })()
                                                                                                                }
                                                                                                            </td>
                                                                                                        }
                                                                                                        {
                                                                                                            this.state.showWeight && 
                                                                                                            <td className="text-center">{taskItem.weight}</td>
                                                                                                        }
                                                                                                        {
                                                                                                            this.state.showYesNoDD &&
                                                                                                            <td>
                                                                                                                <RegularDropdown
                                                                                                                    placeholder={isEmptyVariable(taskItem.rank) ? defaultYNPlaceholder : yNRank}
                                                                                                                    dropdownArr={Constants.yesNoRankArr}
                                                                                                                    labelParam="label"
                                                                                                                    onDropDownItemClick={this.maxrDropdownClick}
                                                                                                                    udf={idx + ":-:" + index}
                                                                                                                    disabled={false}
                                                                                                                />
                                                                                                            </td>
                                                                                                        }
                                                                                                        {
                                                                                                            this.state.showRanking &&
                                                                                                            <td>
                                                                                                                <RegularDropdown
                                                                                                                    placeholder={isEmptyVariable(taskItem.rank) ? defaultWeightPlaceholder : taskItem.rank === -1 ? "N/A" : taskItem.rank}
                                                                                                                    dropdownArr={this.state.rankingArray}
                                                                                                                    labelParam="label"
                                                                                                                    onDropDownItemClick={this.maxrDropdownClick}
                                                                                                                    udf={idx + ":-:" + index}
                                                                                                                    disabled={false}
                                                                                                                />
                                                                                                            </td>
                                                                                                        }
                                                                                                        {
                                                                                                            this.state.execTaskTemplateFields.map((templateItem) => {
                                                                                                                let showHeader = true;
                                                                                                                if (templateItem.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI ||
                                                                                                                    templateItem.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT) {
                                                                                                                    if (templateItem.isFromRiskMaster) {
                                                                                                                        if (templateItem.isRiskMasterEnabled === "Y") {
                                                                                                                            showHeader = true;
                                                                                                                        } else {
                                                                                                                            showHeader = false;
                                                                                                                        }
                                                                                                                    } else {
                                                                                                                        showHeader = true;
                                                                                                                    }
                                                                                                                } 
                                                                                                                return showHeader && this.getExecTaskDisplayTableData(taskItem.assignmentTaskId, templateItem, 
                                                                                                                    taskItem.taskId, this.state.assignmentArea == "CheckList" ? item.checkListHeadingId : item.processId); 
                                                                                                            }
                                                                                                        )}
                                                                                                        {/* if task has no observation linked to it then show create button
                                                                                                        if task has no observation linked to it but completion status is completed then show just "-" */}
                                                                                                        {/* {
                                                                                                            hasFeatureAccess(Constants.FEATURE_OBSERVATION) &&
                                                                                                            !isEmptyVariable(this.state.assignmentDetails.observationTemplateId) &&
                                                                                                            <td>
                                                                                                                {isEmptyVariable(taskItem.observationStatus) && taskItem.completionStatus === "Completed" ? "-" : isEmptyVariable(taskItem.observationStatus) ? "Create" : taskItem.observationStatus}
                                                                                                            </td>
                                                                                                        } */}
                                                                                                        {!isEmptyVariable(this.state.assignmentStatus) && 
                                                                                                        this.state.assignmentStatus === Constants.ASSIGNMENT_STATUS_COMPLETED &&
                                                                                                            <td className="text-center">
                                                                                                                {
                                                                                                                    actionObj.actionArr && actionObj.actionArr.length > 0 && (
                                                                                                                    <TableDropDown
                                                                                                                        actionArr={actionObj.actionArr}
                                                                                                                        onDropDownItemClick={this.onTableDropDownItemClick}
                                                                                                                        dropDownId={taskItem}
                                                                                                                        dropdownWidth={actionObj.dropdownWidth}
                                                                                                                        themeSettings={themeSettings}
                                                                                                                    />
                                                                                                                )}
                                                                                                            </td>
                                                                                                        }
                                                                                                    </tr>
                                                                                                );
                                                                                            }
                                                                                        )}
                                                                                    </tbody>
                                                                                    {/* {this.renderSubTotal(item, "Sub Total")} */}
                                                                                    {/* Grand Total row after last table */}
                                                                                    {/* {this.renderGrandTotal(index)} */}
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                        {
                                                                            this.state.showChecklistScores &&
                                                                            <div className="checklist-scores-layout">
                                                                                <p>{"Max Score: " + item.maxScore}</p>
                                                                                <p> {"Total Score: " + item.totalScore} </p>
                                                                                <p> {"Percentage: " + ((item.totalScore / item.maxScore) * 100).toFixed(1) + "%"} </p>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                )}

                                                                {
                                                                    isEmptyArray(item.taskList) &&
                                                                    <div class="no-items-layout">
                                                                        <div class="no-items-card" style={{ padding: "10px" }} >
                                                                            <h6 style={{ margin: 0, fontSize: "13px", }} >
                                                                                {Constants.NO_RECORDS_WARNING}
                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        )
                                                    );
                                                })
                                            }

                                            {
                                                !isEmptyArray(this.state.datalist) && this.state.assignmentArea === "Function" &&
                                                (this.state.filterDataList.length > 0 ? 
                                                    this.getProcessGroupingTaskList(this.state.filterDataList, this.state.assignmentArea)
                                                    : this.getProcessGroupingTaskList(this.state.datalist, this.state.assignmentArea)
                                                ).map((process) => {
                                                    return !isEmptyArray(process.processTaskList) && Object.values(process.processTaskList).map((item, index) => {
                                                        return (
                                                            !isEmptyArray(item.taskList) && (
                                                                <div className="sticky-main-header">
                                                                    <div className="sticky-exec-header">
                                                                    {
                                                                        <h6 style={{ marginTop: index === 0 ? 5 : 5 }} className="small-h6"> 
                                                                            {!isEmptyVariable(process.functionName) ? process.functionName : ""} 
                                                                        </h6>
                                                                    }
                                                                    <center>
                                                                        <h6 style={{ marginTop: index === 0 ? 5 : 5 }} className="small-h6" >
                                                                            {!isEmptyVariable(item.processName) ? item.processName : ""}
                                                                        </h6>
                                                                    </center>
                                                                    </div>

                                                                    {
                                                                        !isEmptyArray(item.taskList) && (
                                                                        <div>
                                                                            <div className="common-tab-bg">
                                                                                <div className="common-table" style={{ width: "100%" }} >
                                                                                    <table className="table">
                                                                                        <thead className="sticky-exec-header" style={{top:29}}>
                                                                                            <tr>
                                                                                                <th className="text-center" width="38px" > No. </th>
                                                                                                <th width="1%">
                                                                                                    <div className="flex-center-layout justify-content-around">
                                                                                                        {hasFeatureAccess(Constants.FEATURE_EXECUTE_COMMENTS) &&
                                                                                                            <span className="tool" data-title="Comments">C</span>
                                                                                                        }
                                                                                                        {this.state.executionTemplateFixedFields?.annexures === "Y" && (
                                                                                                            <span className="tool" data-title="Annexure">A</span>
                                                                                                        )}
                                                                                                        {this.state.followUpTemplateFixedFields?.backups === "Y" && (
                                                                                                            <span className="tool" data-title="Backups">B</span>
                                                                                                        )}
                                                                                                        {hasFeatureAccess(Constants.FEATURE_EXECUTE_PREVIOUS_OBSERVATION) &&
                                                                                                            <span className="tool" data-title="History">H</span>
                                                                                                        }
                                                                                                    </div>
                                                                                                </th>
                                                                                                {
                                                                                                    this.state.selectedTaskTemplateFields.map((item) => {
                                                                                                        return (
                                                                                                            <th className={item.fieldType === TemplateConstants.FIELD_TYPE_TEXT ? 
                                                                                                                "scrollable-table-task-text-th" : "scrollable-table-task-others-th"}>
                                                                                                                {item.fieldName}
                                                                                                            </th>
                                                                                                        );
                                                                                                    })
                                                                                                }
                                                                                                <th style={{minWidth:"150px"}}>Follow Up Date</th>
                                                                                                <th></th>
                                                                                                {/* {
                                                                                                    this.state.isRisk && !isEmptyVariable(this.state.assignmentDetails.riskId) &&
                                                                                                    <th>Follow Up Risk</th>
                                                                                                } */}
                                                                                                {
                                                                                                    this.state.isRisk && this.state.executionTemplateFixedFields?.assignRisk === "Y" &&
                                                                                                    hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) && this.state.isTemplateSettingRisk &&
                                                                                                    !isEmptyVariable(this.state.assignmentDetails.riskId) &&
                                                                                                    <th>Risk</th>
                                                                                                }
                                                                                                {   
                                                                                                    this.state.showWeight && 
                                                                                                    <th>Weight</th>
                                                                                                }
                                                                                                {
                                                                                                    this.state.showYesNoDD && 
                                                                                                    <th>Rank</th>
                                                                                                }
                                                                                                {
                                                                                                    this.state.showRanking && 
                                                                                                    <th>Rank</th>
                                                                                                }
                                                                                                {
                                                                                                    this.state.execTaskTemplateFields.map(item => {
                                                                                                        let showHeader = true;
                                                                                                        if (item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI ||
                                                                                                            item.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT) {
                                                                                                            if (item.isFromRiskMaster) {
                                                                                                                if (item.isRiskMasterEnabled === "Y") {
                                                                                                                    showHeader = true;
                                                                                                                } else {
                                                                                                                    showHeader = false;
                                                                                                                }
                                                                                                            } else {
                                                                                                                showHeader = true;
                                                                                                            }
                                                                                                        }
                                                                                                        let scoreHeading = true;
                                                                                                        return (
                                                                                                            <>
                                                                                                            {showHeader && 
                                                                                                                <>
                                                                                                                {scoreHeading &&
                                                                                                                    <th className={item.fieldType === TemplateConstants.FIELD_TYPE_TEXT
                                                                                                                        ?"scrollable-table-task-text-th":"scrollable-table-task-others-th"}>
                                                                                                                        {item.fieldName}
                                                                                                                        {item.isMandatorySelected === "Y"?"*":""}
                                                                                                                    </th>
                                                                                                                }
                                                                                                                </>
                                                                                                            }
                                                                                                            </>
                                                                                                        )
                                                                                                    })
                                                                                                }
                                                                                                {/* {
                                                                                                    hasFeatureAccess(Constants.FEATURE_OBSERVATION) &&
                                                                                                    !isEmptyVariable(this.state.assignmentDetails.observationTemplateId) &&
                                                                                                    <th>Observation</th>
                                                                                                } */}
                                                                                                {
                                                                                                    !isEmptyVariable(this.state.assignmentStatus) && 
                                                                                                    this.state.assignmentStatus === Constants.ASSIGNMENT_STATUS_COMPLETED &&
                                                                                                    <th className="text-center"></th>
                                                                                                }
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                                !isEmptyArray(item.taskList) &&
                                                                                                item.taskList.map((taskItem, idx) => {
                                                                                                    if(taskItem.annexureCount>0)
                                                                                                    {
                                                                                                        // this.getAllAnnexureList(taskItem);
                                                                                                    }
                                                                                                    showEmptyCard = false;
                                                                                                    let yNRank = defaultYNPlaceholder;
                                                                                                    let isAuditeeResponse = this.state.menu[Constants.SCREEN_RESPONSE_TEMPLATE] === "ALL" && taskItem.auditeeResponseCount !== 0;
                                                                                                    let actionObj = getFollowUpTasks(taskItem, this.state.assignmentDetails?.reviewAssignmentTask, isAuditeeResponse);
                                                                                                    // For Y/N, get label from yesNoRankArr
                                                                                                    if (this.state.showYesNoDD && !isEmptyVariable(taskItem.rank)) {
                                                                                                        Constants.yesNoRankArr.forEach((rankItem) => {
                                                                                                            if (taskItem.rank === rankItem.id) { yNRank = rankItem.label }
                                                                                                        });
                                                                                                    }
                                                                                                    
                                                                                                    return (
                                                                                                        <tr style={{ background: this.taskEditable(taskItem) ? "#f5f5f5" : "#ffffff" }} >
                                                                                                            <td className="text-center">
                                                                                                                {(this.state.currentPageNo - 1) * this.state.resultSize + (idx + 1)} </td>
                                                                                                            <td>
                                                                                                                <div className="flex-center-layout exec-task-indicators">
                                                                                                                    {hasFeatureAccess(Constants.FEATURE_EXECUTE_COMMENTS) &&
                                                                                                                        <div className="review-comment-layout">
                                                                                                                            <span className="material-icons"
                                                                                                                                style={{
                                                                                                                                    color: taskItem.remarkCount === 0 ? "#777777" : `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                                                                                                                                    opacity: taskItem.remarkCount === 0 ? "0.6" : "1",
                                                                                                                                }}
                                                                                                                                onClick={this.uploadAnnexuresBackupIconClick.bind(this, taskItem.assignmentTaskId, "Comments", this.taskEditable(taskItem), taskItem.userId)}
                                                                                                                                >
                                                                                                                                chat
                                                                                                                            </span>
                                                                                                                            {
                                                                                                                                taskItem.newRemarkCount && taskItem.newRemarkCount != 0 && (
                                                                                                                                <div class="review-comment-badge">
                                                                                                                                    <span>{taskItem.newRemarkCount}</span>
                                                                                                                                </div>
                                                                                                                            )}
                                                                                                                        </div>
                                                                                                                    }
                                                                                                                    {this.state.executionTemplateFixedFields?.annexures === "Y" && (
                                                                                                                        <span className="material-icons"
                                                                                                                            style={{
                                                                                                                                color: taskItem.annexureCount === 0 ? "#777777" : `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                                                                                                                                opacity: taskItem.annexureCount === 0 ? "0.6" : "1",
                                                                                                                            }}
                                                                                                                            onClick={this.uploadAnnexuresBackupIconClick.bind(this, taskItem.assignmentTaskId, "Annexures", this.taskEditable(taskItem))}
                                                                                                                            >
                                                                                                                            file_present
                                                                                                                        </span>
                                                                                                                    )}
                                                                                                                    {
                                                                                                                        this.state.followUpTemplateFixedFields?.backups === "Y" && (
                                                                                                                        <span className="material-icons"
                                                                                                                            style={{
                                                                                                                                color: taskItem.FollowUpBackupCount === 0 ? "#777777" : `rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},1)`,
                                                                                                                                opacity: taskItem.FollowUpBackupCount === 0 ? "0.6" : "1",
                                                                                                                            }}
                                                                                                                            onClick={this.uploadAnnexuresBackupIconClick.bind(this, taskItem.assignmentTaskId, "Backups", this.taskEditable(taskItem))}>
                                                                                                                            cloud_upload
                                                                                                                        </span>
                                                                                                                    )}
                                                                                                                    {hasFeatureAccess(Constants.FEATURE_EXECUTE_PREVIOUS_OBSERVATION) &&
                                                                                                                        <span
                                                                                                                            className="material-icons"
                                                                                                                            style={{ color: "#777777", opacity: "0.6" }}
                                                                                                                            onClick={this.previousAssignmentData.bind(this,taskItem, item.functionId)}>
                                                                                                                            manage_search
                                                                                                                        </span>
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </td>
                                                                                                            {
                                                                                                                this.state.selectedTaskTemplateFields.map((item, taskIdx) => {
                                                                                                                    const isFramework = item.fieldType === TemplateConstants.FIELD_TYPE_FRAMEWORK;
                                                                                                                    const isText = item.fieldType === TemplateConstants.FIELD_TYPE_TEXT;
                                                                                                                    const taskDisplayValues = this.getTaskDisplayValues(taskItem.taskId, item);                                                                                                 
                                                                                                                return (
                                                                                                                    <td onClick={((isFramework || isText) && hasFeatureAccess(Constants.FEATURE_ON_CLICK_TASK_DETAILS))? 
                                                                                                                        this.handleShowTaskDetailsLayout.bind(this, taskItem.taskId) : null} 
                                                                                                                    style={taskIdx + "" === "0" ? { borderLeft: "5px solid " + (taskItem.fatal==="Y"?"#FF0000":taskItem.colorCode) } : {}} >
                                                                                                                        <div className={item.fieldId + "" === "1" ? "dangerouslysethtml-flex" : ""}>
                                                                                                                            {isFramework ? (
                                                                                                                                <div className="task-framework-list">
                                                                                                                                    {taskDisplayValues}
                                                                                                                                </div>
                                                                                                                            ) : (
                                                                                                                                <div 
                                                                                                                                    className={`task-dangerouslysethtml`} 
                                                                                                                                    dangerouslySetInnerHTML={{ __html: taskDisplayValues }} 
                                                                                                                                />
                                                                                                                            )}
                                                                                                                            {
                                                                                                                                taskItem.completionStatus === "Completed" && item.fieldId + "" === "1" && (
                                                                                                                                    <span className="material-icons exec-task-done"> done_all </span>
                                                                                                                                )
                                                                                                                            }
                                                                                                                        </div>
                                                                                                                    </td>
                                                                                                                );
                                                                                                            }
                                                                                                            )}
                                                                                                            <td>
                                                                                                                {
                                                                                                                    isEmptyVariable(taskItem.followUpDate)?"":moment(taskItem.followUpDate).format("DD/MM/YYYY")
                                                                                                                }
                                                                                                            </td>
                                                                                                            <td style={{minWidth:"200px"}}>
                                                                                                                <RegularDD
                                                                                                                    placeholder={isEmptyVariable(taskItem.closeOpenStatus)?this.state.filterOpenClosePlaceholder:taskItem.closeOpenStatus}
                                                                                                                    dropdownArr={this.state.filterOpenCloseDropDownArr}
                                                                                                                    labelParam="label"
                                                                                                                    onDropDownItemClick={this.filterOpenCloseDropDownOnClick.bind(this,taskItem)}
                                                                                                                    udf={idx + ":-:" + index}
                                                                                                                    disabled={this.taskEditable(taskItem)}
                                                                                                                />
                                                                                                            </td>
                                                                                                            {/* {
                                                                                                                !isEmptyVariable(this.state.assignmentDetails.riskId) &&
                                                                                                                <td>
                                                                                                                    {
                                                                                                                        isEmptyVariable(taskItem.followUpRiskLevel)?
                                                                                                                        <div className="risk-level-color-wrapper" style={{ width: "110px",height:"30px", marginLeft:0 }} 
                                                                                                                            onClick={this.taskEditable(taskItem)?null:this.handleSelectRiskDialogShow.bind(this,taskItem)}/>
                                                                                                                        :
                                                                                                                        <div onClick={this.taskEditable(taskItem)?null:this.handleSelectRiskDialogShow.bind(this,taskItem)}>
                                                                                                                            {isEmptyVariable(taskItem.followUpRiskLevel)?"":taskItem.followUpRiskLevel}
                                                                                                                        </div>
                                                                                                                    }
                                                                                                                </td>
                                                                                                            } */}
                                                                                                            {
                                                                                                                this.state.isRisk && this.state.executionTemplateFixedFields?.assignRisk === "Y" && this.state.isTemplateSettingRisk &&
                                                                                                                hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) && !isEmptyVariable(this.state.assignmentDetails.riskId) &&
                                                                                                                <td>
                                                                                                                    {
                                                                                                                    (() => {
                                                                                                                        const showRisk = hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) && !isEmptyVariable(this.state.assignmentDetails.riskId);
                                                                                                                        const showLikelihood = this.state.isLikelihood && hasFeatureAccess(Constants.FEATURE_MATRIX_LIKELIHOOD) && !isEmptyVariable(this.state.assignmentDetails.likelihoodId);
                                                                                                                        const risk = showRisk ? (isEmptyVariable(taskItem.assignmentTaskRiskLevel) ? "" : taskItem.assignmentTaskRiskLevel) : "";
                                                                                                                        const likelihood = showLikelihood ? (isEmptyVariable(taskItem.assignmentTaskLikelihoodLevel) ? "" : taskItem.assignmentTaskLikelihoodLevel) : "";
                                                                                                                        if (showRisk && showLikelihood) {
                                                                                                                            if (risk && likelihood) {
                                                                                                                                return risk + " / " + likelihood;
                                                                                                                            } else if(!risk && !likelihood){
                                                                                                                                return "";
                                                                                                                            } else {
                                                                                                                                return risk +" / " + likelihood;
                                                                                                                            }
                                                                                                                        } else if (showRisk && risk) {
                                                                                                                            return risk;
                                                                                                                        } else if (showLikelihood && likelihood) {
                                                                                                                            return " / " + likelihood;
                                                                                                                        } else {
                                                                                                                            return "";
                                                                                                                        }
                                                                                                                    })()
                                                                                                                }
                                                                                                                </td>
                                                                                                            }
                                                                                                            {   this.state.showWeight && 
                                                                                                                <td className="text-center">{taskItem.weight} </td>
                                                                                                            }
                                                                                                            {
                                                                                                                this.state.showYesNoDD && (
                                                                                                                <td>
                                                                                                                    <RegularDropdown
                                                                                                                        placeholder={isEmptyVariable(taskItem.rank) ? defaultYNPlaceholder : yNRank}
                                                                                                                        dropdownArr={Constants.yesNoRankArr}
                                                                                                                        labelParam="label"
                                                                                                                        onDropDownItemClick={this.maxrDropdownClick}
                                                                                                                        udf={idx + ":-:" + index}
                                                                                                                        disabled={false}
                                                                                                                    />
                                                                                                                </td>
                                                                                                            )}
                                                                                                            {
                                                                                                                this.state.showRanking && (
                                                                                                                <td>
                                                                                                                    <RegularDropdown
                                                                                                                        placeholder={isEmptyVariable(taskItem.rank) ? defaultWeightPlaceholder : taskItem.rank === -1 ? "N/A" : taskItem.rank}
                                                                                                                        dropdownArr={this.state.rankingArray}
                                                                                                                        labelParam="label"
                                                                                                                        onDropDownItemClick={this.maxrDropdownClick}
                                                                                                                        udf={idx + ":-:" + index}
                                                                                                                        disabled={false}
                                                                                                                    />
                                                                                                                </td>
                                                                                                            )}

                                                                                                            {
                                                                                                                this.state.execTaskTemplateFields.map((templateItem) => {
                                                                                                                    let showHeader = true;
                                                                                                                    if (templateItem.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI ||
                                                                                                                        templateItem.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT) {
                                                                                                                        if (templateItem.isFromRiskMaster) {
                                                                                                                            if (templateItem.isRiskMasterEnabled === "Y") {
                                                                                                                                showHeader = true;
                                                                                                                            } else {
                                                                                                                                showHeader = false;
                                                                                                                            }
                                                                                                                        } else {
                                                                                                                            showHeader = true;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    return showHeader && this.getExecTaskDisplayTableData(taskItem.assignmentTaskId, templateItem, 
                                                                                                                        taskItem.taskId, item.functionId);
                                                                                                                }
                                                                                                            )}
                                                                                                            {/* if task has no observation linked to it then show create button if task has no observation linked to it but completion status is completed then show just "-" */}
                                                                                                            {/* {
                                                                                                                hasFeatureAccess(Constants.FEATURE_OBSERVATION) &&
                                                                                                                !isEmptyVariable(this.state.assignmentDetails.observationTemplateId) &&
                                                                                                                <td>
                                                                                                                    {isEmptyVariable(taskItem.observationStatus) && taskItem.completionStatus === "Completed" ? "-" : isEmptyVariable(taskItem.observationStatus) ? "Create" : taskItem.observationStatus}
                                                                                                                </td> 
                                                                                                            } */}
                                                                                                            {
                                                                                                                !isEmptyVariable(this.state.assignmentStatus) && 
                                                                                                                this.state.assignmentStatus === Constants.ASSIGNMENT_STATUS_COMPLETED && (
                                                                                                                <td className="text-center">
                                                                                                                    {actionObj.actionArr && actionObj.actionArr.length > 0 && (
                                                                                                                        <TableDropDown
                                                                                                                            actionArr={actionObj.actionArr}
                                                                                                                            onDropDownItemClick={this.onTableDropDownItemClick}
                                                                                                                            dropDownId={taskItem}
                                                                                                                            dropdownWidth={actionObj.dropdownWidth}
                                                                                                                            themeSettings={themeSettings}
                                                                                                                        />
                                                                                                                    )}
                                                                                                                </td>
                                                                                                            )}
                                                                                                        </tr>
                                                                                                    );
                                                                                                }
                                                                                                )}
                                                                                        </tbody>
                                                                                        {/* {this.renderSubTotal(item, "Sub Total")} */}
                                                                                        {/* Grand Total row after last table */}
                                                                                        {/* {this.renderGrandTotal(index)} */}
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                this.state.showChecklistScores && (
                                                                                <div className="checklist-scores-layout">
                                                                                    <p>{"Max Score: " + item.maxScore}</p>
                                                                                    <p> {"Total Score: " + item.totalScore} </p>
                                                                                    <p> {"Percentage: " + ((item.totalScore / item.maxScore) * 100).toFixed(1) + "%"} </p>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                    {
                                                                        isEmptyArray(item.taskList) && (
                                                                        <div class="no-items-layout">
                                                                            <div class="no-items-card" style={{ padding: "10px" }} >
                                                                                <h6 style={{ margin: 0, fontSize: "13px", }} >
                                                                                    {Constants.NO_RECORDS_WARNING}
                                                                                </h6>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )
                                                        );
                                                    })
                                                })
                                            }
                                            {
                                                this.state.componentDidMountFlag && showEmptyCard && (
                                                <div class="no-items-layout m-t-10">
                                                    <div class="no-items-card">
                                                        <h6>No Tasks</h6>
                                                    </div>
                                                </div>
                                            )}
                                            {
                                                this.state.showChecklistScores && (
                                                <div className="checklist-scores-layout">
                                                    <p> {"Checklist - Max Score: " + this.state.overallChecklistScoreObj?.maxScore} </p>
                                                    <p> {"Total Score: " + this.state.overallChecklistScoreObj?.actualScore} </p>
                                                    <p> {"Percentage: " + this.state.overallChecklistScoreObj?.scorePct + "%"} </p>
                                                </div>
                                            )}
                                        </div>

                                    )
                                }
                                {
                                    this.state.showTaskDetailsLayout && (
                                    <TaskDetailsLayout
                                        taskId={this.state.selectedTaskIdForDetails}
                                        handleHideTaskDetailsLayout={this.handleHideTaskDetailsLayout}
                                        subscriptionType={this.state.user.subscriptionType}
                                        handleShowTaskDetailsLayout={this.handleShowTaskDetailsLayout}
                                        isIndustryFlag={this.state.isIndustryFlag}
                                        assignmentTypeId={this.state.assignmentDetails.assignmentTypeId}
                                        allSettings={this.state.allSettings}
                                    />
                                )}
                            </div>
                        </div>
                        <AlertDialog
                            showAlertDialog={this.state.showAlertDialog}
                            handleAlertDialogClose={this.handleAlertDialogClose}
                            type={Constants.ALERT_TYPE_INFO}
                            alertDialogHeading={this.state.alertDialogHeading}
                            alertDialogMessage={this.state.alertDialogMessage}
                            proceedBtnClick={this.handleRecordOperation}
                            proceedBtnLabel={this.state.proceedBtnLabel}
                            showLoader={this.state.showBtnLoader}
                            themeSettings={themeSettings}
                        />

                        <AlertDialog
                            showAlertDialog={this.state.showAlertDialogInfo}
                            handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                            type={Constants.ALERT_TYPE_ALERT}
                            alertDialogMessage={this.state.alertDialogMessageInfo}
                            proceedBtnClick={this.handleAlertDialogCloseInfo}
                            proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                            themeSettings={themeSettings}
                        />
                       
                        <FollowUpUpdateAssignmentTaskReviewStatus
                            showUpdateReviewDialog={this.state.showUpdateReviewDialog}
                            handleUpdateReviewDialogClose={this.handleUpdateReviewDialogClose}
                            masterDataId={this.state.deleteReactivateId}
                            reviewLevel={this.state.reviewLevel}
                            currentReviewLevel={this.state.currentReviewLevel}
                            endReviewLevel={this.state.endReviewLevel-1}
                            themeSettings={themeSettings}
                        />
                        
                        <SelectRiskDialog
                            showRiskDialog={this.state.showSelectRiskDialog}
                            handleSelectRiskDialogClose={this.handleSelectRiskDialogClose}
                            handleSelectRiskDialogSaveClose={
                                this.handleSelectRiskDialogSaveClose
                            }
                            selectedRiskId={this.state.selectedAssignmentTaskRiskLevelId} // Used to check if the risk is selected or not
                            assignmentTaskId={this.state.assignmentTaskId}
                            riskArr={
                                isEmptyArray(
                                    this.state.deptDefaultRisk[this.state.assignmentDetails.departmentId]
                                )? []
                                    : this.state.deptDefaultRisk[this.state.assignmentDetails.departmentId]
                            }
                            selectedLikelihoodRiskId={this.state.selectedLikelihoodRiskId} // Used to check if the likelihood is selected or not
                            likelihoodRiskMatrix={this.state.likelihoodRiskMatrix} // Used to show the likelihood risk matrix
                            observationId={this.state.observationId}
                            selectedRiskObj={this.state.selectedRiskObj}
                            isLikelihood={this.state.isLikelihood} // Used to check if the likelihood setting is enabled or not
                            assignmentLikelihoodId={this.state.assignmentDetails.likelihoodId} // Used for checking if the likelihood value is assigned or not inside the assignment
                            themeSettings={themeSettings}
                        />

                        <ReviewHistoryDialog
                            showReviewHistoryDialog={this.state.showReviewHistoryDialog}
                            handleReviewHistoryDialogClose={this.handleReviewHistoryDialogClose}
                            masterType={"Follow Up Assignment Task"}
                            masterDataId={this.state.deleteReactivateId}
                        />
                    
                        <AddFollowUpTemplateValueDialog
                            showFollowUpTemplateValueDialog={this.state.showFollowUpTemplateValueDialog}
                            handleFollowUpTemplateValueDialogClose={this.handleFollowUpTemplateValueDialogClose}
                            isFollowUpTemplateValueEditDialog={false}
                            themeSettings={themeSettings}
                            followUpTaskTemplateList={this.state.followUpTaskTemplateList}
                            backups={this.state.fixedTemplateFields?.backups}
                            assignmentTaskId={this.state.assignmentTaskId}
                            assignmentId={this.state.assignmentId}
                            selectFollowUpTemplate={this.state.selectFollowUpTemplate}
                            title={"Follow Up"}
                        />
                        <ViewResponseCommentDialog
                            showViewResponseDialog={this.state.showViewResponseDialog}
                            handleViewResponseDialogClose={this.handleViewResponseDialogClose}
                            assignmentTaskId={this.state.selectedAssignmentTaskId}
                            assignmentId={this.state.assignmentId}
                            themeSettings={themeSettings}
                            location={this.props.location}
                            observationId={this.state.selectedObservationId}
                            isDraftOnward={true}
                        />
                        {this.state.showFollowUpDetailsDialog &&
                            <FollowUpDetailsDialog
                                showFollowUpDetailsDialog={this.state.showFollowUpDetailsDialog}
                                followUpDetailsItem={this.state.followUpDetailsItem}
                                handleFollowUpDetailsDialogClose={this.handleFollowUpDetailsDialogClose}
                                themeSettings={themeSettings}
                                item={this.state.followUpTaskItem}
                                assignmentTaskId={this.state.assignmentTaskId}
                                assignmentId={this.state.assignmentId}
                            />
                        }
                        
                        <UploadAnnexureDialog
                            showUploadAnnexureDialog={this.state.showSelectUploadAnnexureDialog}
                            handleSelectUploadAnnexureDialogClose={this.handleSelectUploadAnnexureDialogClose}
                            isEditable={this.state.isEditable}
                            type={this.state.isBackup ? "Backup" : "Annexure"}
                            assignmentTaskId={this.state.deleteReactivateId}
                            themeSettings={themeSettings}
                        />
                        <ReviewCommentsDialog
                            showReviewCommentsDialog={this.state.showReviewCommentsDialog}
                            handleReviewCommentsDialogClose={this.handleReviewCommentsDialogClose}
                            masterDataId={this.state.deleteReactivateId}
                            assignmentId={this.state.assignmentId}
                            themeSettings={themeSettings}
                            assignmentMatrix={this.state.assignmentMatrix}
                            type={this.state.type}
                            isDraftOnward={true}
                            assignmentTaskAllowEdit={"N"}
                            assignmentTaskUserId={this.state.assignmentTaskUserId}
                        />
                        <PreviousAssignmentDialog
                            showDialogBox={this.state.showPreviousAssignmentData}
                            closeDialogBox={this.closePreviousAssignDialogBox}
                            assignmentExecuteFields ={this.state.assignmentExecuteFields}
                            dataList={this.state.previousAssignmentDataList}
                            themeSettings={themeSettings}
                        />
                        <FrameworkClauseInfoDialog
                            showFrameworkClauseInfoDialog={this.state.showFrameworkClauseInfoDialog}
                            handleFrameworkClauseDialogClose={this.handleFrameworkClauseDialogClose}
                            framworkClaueItem={this.state.framworkClaueItem}
                            frameworkName={this.state.frameworkName}
                        />
                    </section>
                </main>
            </Router>
        );
    }
}

export default FollowUpTask;
